// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Make sure this variables file always gets loaded first */
.color--light-gray {
  color: #9a9a9a;
}

.color--target-red {
  color: #cc0000;
}

.color--white {
  color: #fff;
}

.color--blue {
  color: rgb(5, 70, 207);
}

.color--success {
  color: #7fc14a;
}

.color--error {
  color: #cc0000;
}

.color--body {
  color: #6A6A6A;
}

.color--body-dark {
  color: #333;
}

.color--teal {
  color: #309ab0;
}

.color--green {
  color: #7fc14a;
}

.color--light-green {
  color: #e9f3e4;
}

.color--light-green-alt {
  color: #39b54a;
}

.bg-color--light-gray {
  background-color: #9a9a9a;
}

.bg-color--body {
  background-color: #6A6A6A;
}

.bg-color--body-dark {
  background-color: #333;
}

/**
Credits: mikewgd - http://snippetrepo.com/snippets/sass-mixin-for-vendor-prefix
@mixin vendor
Easily apply styles and adding vendor prefixes will be added with ease.
@param name - css property
@param arg - css values
Usage: @include vendor(border-radius, 4px);
**/
/**
Credits: mikewgd - http://snippetrepo.com/snippets/sass-mixin-for-vendor-prefix
@mixin vendor
Easily apply styles and adding vendor prefixes will be added with ease.
@param name - css property
@param arg - css values
Usage: @include vendor(border-radius, 4px);
**/
/*! normalize.css v3.0.2 | MIT License | github.com/necolas/normalize.css */
/**
 * 1. Set default font family to sans-serif.
 * 2. Prevent iOS text size adjust after orientation change, without disabling
 *    user zoom.
 */
html {
  font-family: sans-serif; /* 1 */
  -ms-text-size-adjust: 100%; /* 2 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/**
 * Remove default margin.
 */
body {
  margin: 0;
}

/* HTML5 display definitions
   ========================================================================== */
/**
 * Correct \`block\` display not defined for any HTML5 element in IE 8/9.
 * Correct \`block\` display not defined for \`details\` or \`summary\` in IE 10/11
 * and Firefox.
 * Correct \`block\` display not defined for \`main\` in IE 11.
 */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}

/**
 * 1. Correct \`inline-block\` display not defined in IE 8/9.
 * 2. Normalize vertical alignment of \`progress\` in Chrome, Firefox, and Opera.
 */
audio,
canvas,
progress,
video {
  display: inline-block; /* 1 */
  vertical-align: baseline; /* 2 */
}

/**
 * Prevent modern browsers from displaying \`audio\` without controls.
 * Remove excess height in iOS 5 devices.
 */
audio:not([controls]) {
  display: none;
  height: 0;
}

/**
 * Address \`[hidden]\` styling not present in IE 8/9/10.
 * Hide the \`template\` element in IE 8/9/11, Safari, and Firefox < 22.
 */
[hidden],
template {
  display: none;
}

/* Links
   ========================================================================== */
/**
 * Remove the gray background color from active links in IE 10.
 */
a {
  background-color: transparent;
}

/**
 * Improve readability when focused and also mouse hovered in all browsers.
 */
a:active,
a:hover {
  outline: 0;
}

/* Text-level semantics
   ========================================================================== */
/**
 * Address styling not present in IE 8/9/10/11, Safari, and Chrome.
 */
abbr[title] {
  border-bottom: 1px dotted;
}

/**
 * Address style set to \`bolder\` in Firefox 4+, Safari, and Chrome.
 */
b,
strong {
  font-weight: bold;
}

/**
 * Address styling not present in Safari and Chrome.
 */
dfn {
  font-style: italic;
}

/**
 * Address variable \`h1\` font-size and margin within \`section\` and \`article\`
 * contexts in Firefox 4+, Safari, and Chrome.
 */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/**
 * Address styling not present in IE 8/9.
 */
mark {
  background: #ff0;
  color: #000;
}

/**
 * Address inconsistent and variable font size in all browsers.
 */
small {
  font-size: 80%;
}

/**
 * Prevent \`sub\` and \`sup\` affecting \`line-height\` in all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

/* Embedded content
   ========================================================================== */
/**
 * Remove border when inside \`a\` element in IE 8/9/10.
 */
img {
  border: 0;
}

/**
 * Correct overflow not hidden in IE 9/10/11.
 */
svg:not(:root) {
  overflow: hidden;
}

/* Grouping content
   ========================================================================== */
/**
 * Address margin not present in IE 8/9 and Safari.
 */
figure {
  margin: 1em 40px;
}

/**
 * Address differences between Firefox and other browsers.
 */
hr {
  box-sizing: content-box;
  height: 0;
}

/**
 * Contain overflow in all browsers.
 */
pre {
  overflow: auto;
}

/**
 * Address odd \`em\`-unit font size rendering in all browsers.
 */
code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}

/* Forms
   ========================================================================== */
/**
 * Known limitation: by default, Chrome and Safari on OS X allow very limited
 * styling of \`select\`, unless a \`border\` property is set.
 */
/**
 * 1. Correct color not being inherited.
 *    Known issue: affects color of disabled elements.
 * 2. Correct font properties not being inherited.
 * 3. Address margins set differently in Firefox 4+, Safari, and Chrome.
 */
button,
input,
optgroup,
select,
textarea {
  color: inherit; /* 1 */
  font: inherit; /* 2 */
  margin: 0; /* 3 */
}

/**
 * Address \`overflow\` set to \`hidden\` in IE 8/9/10/11.
 */
button {
  overflow: visible;
}

/**
 * Address inconsistent \`text-transform\` inheritance for \`button\` and \`select\`.
 * All other form control elements do not inherit \`text-transform\` values.
 * Correct \`button\` style inheritance in Firefox, IE 8/9/10/11, and Opera.
 * Correct \`select\` style inheritance in Firefox.
 */
button,
select {
  text-transform: none;
}

/**
 * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native \`audio\`
 *    and \`video\` controls.
 * 2. Correct inability to style clickable \`input\` types in iOS.
 * 3. Improve usability and consistency of cursor style between image-type
 *    \`input\` and others.
 */
button,
html input[type=button],
input[type=reset],
input[type=submit] {
  -webkit-appearance: button; /* 2 */
  cursor: pointer; /* 3 */
}

/**
 * Re-set default cursor for disabled elements.
 */
button[disabled],
html input[disabled] {
  cursor: default;
}

/**
 * Remove inner padding and border in Firefox 4+.
 */
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/**
 * Address Firefox 4+ setting \`line-height\` on \`input\` using \`!important\` in
 * the UA stylesheet.
 */
input {
  line-height: normal;
}

/**
 * It's recommended that you don't attempt to style these elements.
 * Firefox's implementation doesn't respect box-sizing, padding, or width.
 *
 * 1. Address box sizing set to \`content-box\` in IE 8/9/10.
 * 2. Remove excess padding in IE 8/9/10.
 */
input[type=checkbox],
input[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Fix the cursor style for Chrome's increment/decrement buttons. For certain
 * \`font-size\` values of the \`input\`, it causes the cursor style of the
 * decrement button to change from \`default\` to \`text\`.
 */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Address \`appearance\` set to \`searchfield\` in Safari and Chrome.
 * 2. Address \`box-sizing\` set to \`border-box\` in Safari and Chrome
 *    (include \`-moz\` to future-proof).
 */
input[type=search] {
  -webkit-appearance: textfield; /* 1 */ /* 2 */
  box-sizing: content-box;
}

/**
 * Remove inner padding and search cancel button in Safari and Chrome on OS X.
 * Safari (but not Chrome) clips the cancel button when the search input has
 * padding (and \`textfield\` appearance).
 */
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * Define consistent border, margin, and padding.
 */
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

/**
 * 1. Correct \`color\` not being inherited in IE 8/9/10/11.
 * 2. Remove padding so people aren't caught out if they zero out fieldsets.
 */
legend {
  border: 0; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Remove default vertical scrollbar in IE 8/9/10/11.
 */
textarea {
  overflow: auto;
}

/**
 * Don't inherit the \`font-weight\` (applied by a rule above).
 * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.
 */
optgroup {
  font-weight: bold;
}

/* Tables
   ========================================================================== */
/**
 * Remove most spacing between table cells.
 */
table {
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  padding: 0;
}

/**
* Forms
**/
.form-textarea {
  resize: none;
  width: 100%;
  padding: 1em;
  height: 13em;
  color: #6A6A6A;
}

.form-textarea__count {
  font-size: 0.75em;
  color: white;
}

.form-input--text {
  width: 100%;
  padding: 1em;
}

/* Components */
/* nothing in here should ever conflict */
.sidebarlink {
  display: flex;
  color: #e1e9fc;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 40px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 18px;
  color: #495057;
}

.searchDiv {
  width: 10%;
  padding: 1%;
}

.container {
  position: fixed;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 50px;
  box-shadow: 0 2px 0px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  z-index: 800;
  top: 0px;
  justify-content: space-between;
}

.imageHolder {
  padding: 3px 13px;
  display: inline-flex;
  border-right: 1px solid rgb(204, 204, 204);
  width: 50%;
}

.textStyle1 {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.textStyleGray {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: #d3d3d3;
}

.auctionSales {
  width: 250px;
  height: 20px;
  margin: 5px 0 7px 15.5px;
  font-family: "ToyotaTypeBook";
  font-size: 16px;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: normal;
  align-self: center;
}

.dealerName,
.userInfo {
  padding: 0px 0px 0px 10px;
  font-family: "ToyotaTypeBook";
  font-size: 13px;
  font-weight: 600;
  line-height: 1.54;
  letter-spacing: normal;
  color: #080707;
  display: inline-flex;
}

#dealer-menu {
  top: 34px !important;
}

#tenant-menu {
  top: 34px !important;
}

.brandingWrapper,
.dealerContianer,
.rightContainer {
  display: flex;
}

.dealerContianer,
.dealerName,
.userInfo {
  align-items: center;
}

.dealerContianer,
.userInfo {
  padding-right: 32px;
}

.searchLabel {
  height: 18px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #3e3e3c;
}

.searchLabelHeader {
  height: 28px;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #3e3e3c;
  margin-bottom: 20px;
}

.grounding {
  margin-left: 40%;
  position: relative;
  margin-top: 10%;
}

.noMatchesFrame {
  width: 425px;
  height: 76px;
  padding: 14px 30px 16px 16px;
  border-radius: 4px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #dddbda;
  background-color: #ffffff;
  display: block;
  margin: 1% 0 0 0;
}

.noMatches {
  height: 18px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #3e3e3c;
}

.carRecordFound {
  width: 425px;
  height: 50px;
  margin-top: 8px;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #dddbda;
  background-color: #ffffff;
}

.imageFound {
  width: 162px;
  height: 130px;
  margin: 18px 10px 2px 2px;
  border-radius: 4px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}

.line {
  width: 340px;
  height: 1px;
  margin: 4px 0 8px;
  border: solid 1px #c23934;
}

.label {
  width: 85px;
  height: 18px;
  margin: 8px 24px 4px 0;
  font-family: ToyotaTypeBook;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #3e3e3c;
}

.value {
  width: 85px;
  height: 18px;
  margin: 8px 24px 4px 0;
  font-family: ToyotaTypeBook;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #3e3e3c;
  font-weight: normal;
}

.cardSection {
  display: flex;
  flex-direction: row;
}

.cardContent {
  display: flex;
  flex-direction: row;
}

.vehicleMakeModel {
  margin: 0 69px 0 0;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #080707;
}

.home {
  background: #f3f2f2;
  height: 100vh;
  overflow: scroll;
}

.form {
  height: 70vh;
  overflow: auto;
}

.customerReturnDate {
  width: 425px;
  height: 32px;
  margin-top: 10px !important;
  background-color: #ffffff !important;
}

.customerReturnStyle {
  margin-top: 20px;
}

.groundVehicleMFS {
  width: 425px;
  height: 70px;
  margin-top: 20px;
  padding: 8px 16px;
  border-radius: 4px;
  border: solid 1px #dddbda;
  background-color: #faffbd;
}

.groundVehicleMFS p {
  width: 339px;
  height: 54px;
  font-family: "ToyotaTypeBook";
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #3e3e3c;
}

.odometer {
  width: 425px;
  margin-top: 20px !important;
  background-color: #ffffff !important;
}

.odometerBox {
  width: 450px;
  margin-top: 20px !important;
}

.groundVehiclePLV {
  width: 425px;
  height: 70px;
  margin-top: 20px;
  padding: 8px 16px;
  border-radius: 4px;
  border: solid 1px #dddbda;
  background-color: #faffbd;
}

.groundVehiclePLV p {
  width: 339px;
  height: 54px;
  font-family: "ToyotaTypeBook";
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #3e3e3c;
}

.keysReturnedBox {
  margin-top: 20px !important;
}

.keysReturned {
  margin-top: 20px !important;
  margin-right: 10px !important;
  background-color: #ffffff !important;
}

.Rectangle-3 {
  width: 174px;
  height: 52px;
  margin: 8px 23px 0 0;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #dddbda;
  background-color: #ffffff;
  display: inline-flex;
}

.vehicleCondition {
  margin-top: 20px !important;
}

.pickUpLocationBox {
  width: 371px;
  height: 100px;
  margin: 8px 0 0;
  padding: 8px 16px;
  border-radius: 4px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #dddbda;
  background-color: #ffffff;
}

.pickUpLocation {
  margin-top: 20px;
}

.MuiStepIcon-root.MuiStepIcon-active {
  color: #0091ff !important;
}

.MuiStepIcon-root.MuiStepIcon-completed {
  color: #0091ff !important;
}

.MuiButton-containedPrimary {
  background-color: #0070d2 !important;
}

.listingPageCard {
  position: relative;
  top: 60px;
  background-color: #ffffff;
  margin: 2% 3%;
}

.Year-Make-Model-Col {
  border-radius: 4px;
  margin-top: 5%;
  background-color: #ffffff;
}

.Year-Make-Model-Col-details {
  border-radius: 4px;
  margin-top: 3%;
  background-color: #ffffff;
}

.grounding-Vehicle-Price-Option {
  margin-top: 5%;
  border-radius: 4px;
  background-color: #ffffff;
}

.Vehicle-Price-Option {
  margin-top: 5%;
  border-radius: 4px;
  background-color: #ffffff;
  max-width: 250px;
}

.priceOptions {
  display: flex !important;
  justify-content: space-between;
  width: 100%;
}

.VehicleStepper {
  margin-top: -2%;
  border-radius: 4px;
}

div.vehicleMakeModel {
  font-size: 13px;
}

div.vehicleMakeModel1 {
  font-size: 16px;
  font-weight: bold;
}

.textStyle {
  font-family: ToyotaTypeBook;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.9;
  letter-spacing: normal;
  color: #080707;
  display: block;
}

.margin__space {
  margin-left: 19%;
}

.margin__space1 {
  margin-left: 55%;
}

.margin__space2 {
  margin-left: 21.5%;
}

.margin__space3 {
  margin-left: 56%;
}

.margin__space4 {
  margin-left: 20%;
}

.margin__space5 {
  margin-left: 16%;
}

.margin__space6 {
  margin-left: 27.5% !important;
}

.textStyleTotalFee {
  font-size: 14px;
  font-weight: 800 !important;
  font-family: ToyotaTypeBook;
  color: #cc0000;
}

.totalFeeSum {
  font-size: 21px;
  font-weight: 1000 !important;
  font-family: ToyotaTypeBook;
  margin-left: 5%;
}

.textBold {
  font-weight: 1000 !important;
  font-family: ToyotaTypeBook;
}

.textSize {
  font-size: 14px;
}

.MuiCheckbox-root {
  color: #dddbda !important;
  width: 16px !important;
  height: 16px !important;
  margin: 2px 8px 2px 0 !important;
  padding: 5.2px 3.8px 6.8px 4.2px !important;
  border-radius: 2px !important;
  border: solid 1px #dddbda !important;
  background-color: #fff !important;
}

.PassonVehicleStyle {
  width: 120px;
  height: 32px;
  margin: 2px 9px 0 0 !important;
  padding: 1px 0px !important;
  border-radius: 4px;
  background-color: #e0e0e0 !important;
  color: #ffffff !important;
  text-transform: initial !important;
  margin-bottom: 10px !important;
}

.progressStyle {
  width: 70%;
  margin: 10px 0 10px 0;
  display: flex;
}

.img {
  display: block;
  max-width: 400px;
  overflow: hidden;
  width: 78%;
  margin: auto;
  border: 1px solid lightgray;
}

.pendingImgBlock {
  padding: 4% 10% !important;
}

.pendingImg {
  display: block;
  max-width: 263px;
  width: 100%;
  overflow: hidden;
  border: 1px solid lightgray;
}

.NavigatorButtons {
  margin-top: 5px;
}

.textStyleWarning {
  color: #cc0000;
}

.MuiLinearProgress-root {
  height: 10px !important;
  width: inherit;
}

.MuiLinearProgress-barColorSecondary {
  background-color: #cc0000 !important;
}

.MuiLinearProgress-colorSecondary {
  background-color: #d8d8d8 !important;
}

.button {
  width: 135px;
  height: 32px;
  text-transform: initial !important;
  margin-bottom: 10px !important;
  padding: 1px 0px !important;
}

.purchasedScreenTotal {
  width: 250px;
  height: 2px;
  margin: 8px 0 5px;
  background-color: #dddbda;
}

.paddingCSS {
  padding: 0px !important;
}

.MuiCheckbox-colorSecondary.Mui-checked {
  color: #0070d2 !important;
}

.checkedIcon {
  width: 20px;
  height: 20px;
  border: solid 1px #dddbda !important;
  border-radius: 3px;
}

.nodataImage {
  width: 500px;
  height: 300px;
}

.listingPageCardNoData {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 100vh;
}

.loadingSpinneradminReportSearch {
  position: relative;
  padding-top: 30%;
  left: 50%;
}

.nodataText {
  font-size: 22px;
  font-weight: 300;
}

.loaderText {
  font-size: 22px;
  font-weight: 300;
  text-align: center;
}

.vin {
  color: #0091ff;
  cursor: pointer;
  text-decoration: none;
}

.vehicalPriceOptions {
  padding: 3px 15px 3px 0px;
}

.vehiclepriceopt {
  display: flex;
  justify-content: space-between;
  padding: 1px;
}

.sidebarlink {
  display: flex;
  color: #e1e9fc;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 40px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 18px;
  color: #495057;
}

.searchInput {
  width: 425px;
  border: none;
}

.searchDiv {
  width: 10%;
  padding: 1%;
}

.search {
  width: 425px;
  height: 32px;
  margin-top: 10px;
  padding-left: 10px;
  border-radius: 4px;
  border: solid 1px #dddbda;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
}

.myContainerLayout {
  display: flex;
  width: 100%;
}

.conditionPageCard {
  width: 100%;
  padding-top: 50px;
}

.ungroundConditionPageCard {
  width: 100%;
}

.purchasesidebar {
  width: 410px;
  background-color: white;
}

.reportTitle {
  height: 30px;
  font-family: ToyotaType;
  font-size: 17px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #080707;
}

.damageTitle {
  width: 100%;
  height: 30px;
  font-family: ToyotaType;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #080707;
  text-align: center;
  display: block;
}

.pendingReport {
  width: 100%;
  height: 30px;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.25);
  text-align: center;
  display: block;
}

.Pending-Inspection-R {
  width: 165px;
  height: 20px;
  margin-left: 31%;
  font-family: ToyotaType;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.25);
}

.ConditionReportSection {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0px !important;
  width: 100%;
}

.ConditionCardBody {
  margin: 8px 0px 15px;
  padding: 16px;
  border-radius: 4px;
  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}

.ConditionReportInspection {
  padding: 8px;
  border-radius: 100px;
  background-color: #04844b;
}

.ConditionReportInspectionPending {
  padding: 4px 8px;
  border-radius: 100px;
  background-color: #c23934;
}

.BadgeValue {
  width: 122px;
  height: 15px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}

.inspectionStatusWarning {
  background-color: #c00;
  height: 33px;
  padding: 4px 8px;
  border-radius: 100px;
  margin-left: auto;
  width: 140px;
}

.ConditionCard {
  height: 70px;
  border-radius: 4px;
  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}

.ConditionCardDamage {
  width: 90%;
  margin-top: 12px;
  border-radius: 4px;
  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}

.detailedReport {
  font-size: 0.685rem !important;
  font-weight: bold !important;
  border-radius: 4px;
  text-align: center;
  border: solid 1px #0070d2;
  background-color: #ffffff;
}

.disclaimer {
  height: 50px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
}

.closeButton {
  text-transform: capitalize !important;
}

.smallCardTitle {
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #3e3e3c !important;
}

.smallCardTitle1 {
  margin: 0 0 10px;
  font-size: 11.6px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #3e3e3c;
}

.smallCardBody {
  height: 24px;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #080707;
}

.inputFieldTextArea {
  width: 100%;
  height: 180px !important;
  margin: 2px 0 0;
  padding: 8px 4px 4px 12px;
  border-radius: 4px;
  border: solid 1px #dddbda;
  background-color: #ffffff;
  resize: none;
}

.inputFieldTextAreaDamage {
  width: 100%;
  height: 80px !important;
  margin: 2px 0 0;
  padding: 8px 4px 4px 12px;
  border-radius: 4px;
  border: solid 1px #dddbda;
  background-color: #ffffff;
  resize: none;
}

.LabelTextTextArea {
  width: 94px;
  height: 18px;
  margin: 0 6px 0 0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #3e3e3c;
}

.LabelTextTextAreaDamage {
  margin: 5px 6px 0 0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #3e3e3c;
}

.vehicleSectionCR {
  margin: 16px 10px 40px 10px;
  padding: 16px 9px 32px 24px;
  border-radius: 4px;
  background-color: #ffffff;
}

.table {
  min-width: 250;
}

.MuiTableCell-root {
  border-bottom: none !important;
}

.MuiTableHead-root {
  background-color: #fafaf9;
  color: #514f4d !important;
}

.MuiTableCell-sizeSmall {
  padding: 6px 24px 6px 16px;
  color: #514f4d !important;
  font-size: 13px;
}

.MuiButton-label {
  cursor: pointer;
}

.align_right {
  font-weight: 900 !important;
  font-size: 13px !important;
  line-height: 20px !important;
}

.MuiTableContainer-root {
  box-shadow: none !important;
}

.disclaimerVRS {
  margin: 7.5px 0 0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
  color: #e02020;
}

.warningColor {
  color: #0070d2;
}

.warningColorTable {
  color: #0070d2 !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.viewReportBody {
  width: 100%;
  margin-left: 20%;
}

.vehicleDetailsMargin {
  margin-left: 10px !important;
  margin-right: 10px !important;
}

.viewReportCards {
  box-shadow: none !important;
  padding: 10px;
  width: 150px;
}

.viewReportHeader {
  text-align: center;
  font-size: 18px;
  font-weight: 900 !important;
}

.techIssuesHeader {
  text-align: center;
  font-size: 18px;
  font-weight: 900 !important;
  background-color: #c23934;
}

.techIssueCenter {
  font-size: 20px;
  margin: 0px 30px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  background-color: white;
}

.viewReportCenter {
  font-size: 20px;
  margin: 0px 30px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #080707;
}

.image-gallery-svg {
  height: 50px !important;
}

.ConditionCardReportSpace {
  padding-top: 15px;
}

.ungroundConditionCardReportSpace {
  padding-top: 10px !important;
}

.conditionTopBar {
  height: 40px;
  z-index: 10;
  background-color: #ffffff;
  border-bottom: 1px solid lightgray;
}

.conditionTopBarStyles {
  width: 109px;
  height: 20px;
  margin: 3px 0 3px 8px;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: #006dcc;
  position: relative;
}

.conditionTopBarLayout {
  margin-left: 4%;
  float: right;
  padding: 8px;
}

.reportFooter {
  margin: 32px 0 0;
  padding: 12px 16px 12px 804px;
  box-shadow: 0 -2px 0 0 #dddbda;
  background-color: #f3f2f2;
}

.closeButton {
  width: 61px;
  height: 32px;
  padding: 1px 13.5px;
  border-radius: 4px;
  color: #ffffff !important;
}

.saveBtnEnable {
  background-color: #3f51b5 !important;
}

.notesCharCount {
  align-self: flex-end;
}

.noteSubSection {
  display: flex;
  flex-direction: column;
}

.closePassBtn {
  width: 80px;
  height: 32px;
  padding: 1px 13.5px;
  border-radius: 4px;
  color: #ffffff !important;
  background-color: #0070d2 !important;
}

.galleryView {
  float: left;
}

.hrLine {
  height: 1px;
  margin: 8px 0px;
  background-color: #dddbda;
}

.alignleft {
  float: left;
}

.paddingTop {
  margin-top: 20px !important;
}

.accessoriestextStyle {
  text-transform: capitalize !important;
}

.experiorSpacing {
  padding: 0px 30px;
}
.experiorSpacing .MuiList-padding {
  padding-top: 0px !important;
}
.experiorSpacing .MuiListItem-gutters {
  padding-left: 0px !important;
}

.textStyle1 {
  color: white;
}

.errorColor {
  color: #c23934;
}

.galleryView .image-gallery-image {
  max-height: 465px !important;
}

.codereportimggallery .image-gallery-thumbnails-wrapper {
  width: 35vw !important;
}

.image-gallery-thumbnail-image {
  max-height: 70px !important;
}

.accessoriestextStyle {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: left;
  padding: 5px;
}

.accessoriestinlineextStyle {
  width: 33%;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
}
.accessoriestinlineextStyle p {
  font-size: 14px !important;
}

.image-gallery-content {
  overflow-x: hidden;
}

.textWidth {
  width: 140px;
}

.detailedReportRates {
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: right;
  padding: 10px;
}

.imageReportSection {
  width: 100%;
  margin: 24px 1px 16px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);
  padding-top: 40px;
}

.icontooltip {
  display: inline-flex;
}

.align_right11 {
  font-weight: 900px !important;
}

.icontooltip {
  margin-top: -8px;
}

.MuiRadio-colorSecondary.Mui-checked {
  color: #0070d2 !important;
}

.updateMileagePrice {
  padding-top: 16px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.arbitrationReviewRightPanel {
  width: calc(100% + 24px);
}

.locationData {
  display: flex;
  flex-direction: column;
  text-align: end;
}

.paddingCSS-arbitrationReview {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.inspectionData {
  display: flex;
  flex-direction: row;
}

.inputFieldTextAreaArbitrationReview {
  width: 100%;
  margin: 2px 0 0;
  padding: 8px 4px 4px 12px;
  border-radius: 4px;
  border: solid 1px #dddbda;
  background-color: #ffffff;
  resize: none;
}

.arbitrationSubmit {
  text-align: center;
  padding-top: 1rem;
}

.formControl {
  width: 125px;
}

.adminNoteHeading {
  vertical-align: top !important;
}

.dealerNoteStyle {
  display: flex;
  justify-content: space-between;
}

.reviewWidth {
  width: 400px !important;
  text-align: end;
}

.reportSubTitle {
  font-weight: 500 !important;
}

.rightPanelDataRight {
  align-self: center;
}

.dealerNotesData {
  padding: 0.5px 8px;
  border: 1px solid rgb(224, 224, 224);
  border-radius: 4px;
  max-width: 200px;
}

.reportVhcleTitle {
  display: table-cell;
  width: 240px;
}

.addressData {
  text-transform: capitalize;
}

.adminSearchCard {
  width: 700px;
  position: relative;
  top: 101px;
  left: 20%;
  height: 275px;
}

.adminSearchCardBody {
  display: flex;
  padding-right: 5px;
  margin: 25px;
}

.adminSearcheader {
  text-align: center;
  display: flex;
  background-color: #000;
  background-image: linear-gradient(258deg, #000, var(--black));
}

.adminSearcheaderColor {
  color: #ffffff;
  margin-top: 20px;
}

.cover {
  width: 200px;
  padding: 2%;
}

.topBarAdmin {
  height: 48px;
  top: 50px !important;
  background-color: #ffffff !important;
  color: #080707 !important;
  margin: auto;
}

.tabset {
  display: flex;
  justify-content: center;
  margin: 0 auto;
}
.tabset .MuiTabs-indicator {
  bottom: unset !important;
  top: 0 !important;
  height: 3px;
  background-color: #407ed2 !important;
}
.tabset .Mui-selected {
  background: #e7f3fd !important;
}

.tablepagination .MuiTablePagination-select {
  background-color: white;
}

.adminTabsSection {
  width: 100%;
  padding-top: 90px;
}

.notesSection {
  width: 280px;
  height: calc(100vh - 50px);
  background-color: #ffffff;
  z-index: 1110 !important;
  position: sticky;
  top: 50px;
  overflow-y: auto;
  box-shadow: 1px 2px 4px #969696;
}

.manualPricingSidebar {
  height: calc(100vh - 53px);
  background-color: #ffffff;
  z-index: 3 !important;
  position: fixed;
  margin-top: 52px;
  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);
  overflow-y: auto;
}

.updatePricingSidebar {
  height: calc(100vh - 53px);
  background-color: #ffffff;
  z-index: 1110 !important;
  position: sticky;
  top: 50px;
  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);
  min-width: 350px;
  overflow-y: auto;
}

.updateUngroundingSidebar {
  height: calc(100vh - 53px);
  background-color: #ffffff;
  z-index: 1110 !important;
  position: sticky;
  top: 50px;
  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);
  width: 450px;
  overflow-y: auto;
}

.swipeFilterBtn {
  position: sticky !important;
  bottom: 0;
  left: 0;
  padding: 8px 16px;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  background: #fff;
}

.purchasePassBtn {
  display: flex;
  justify-content: space-around;
  width: 100%;
  background: #fff;
}

.passButton {
  width: 140px;
  height: 32px;
  margin: 0 8px 0 0;
  padding: 1px 6px 1px 7px;
  border-radius: 4px;
  border: solid 1px #0070d2 !important;
  font-size: 0.65rem !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5 !important;
}

.passButtonDisabled {
  width: 130px;
  background-color: #e0e0e0 !important;
  color: #ffffff !important;
  border: 0 !important;
}

.purchaseButton {
  width: 140px;
  height: 30px;
  font-size: 0.65rem !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5 !important;
  letter-spacing: normal;
  text-align: center;
  color: #fff !important;
  background: #0070d2 !important;
  border-radius: 4px !important;
  border: solid 1px grey !important;
}

.purchaseButtonDisabled {
  width: 130px;
  height: 32px;
  background-color: #e0e0e0 !important;
  color: #ffffff !important;
  border: 0 !important;
}

.updateButton {
  padding: 4px 8px;
  min-width: 100px !important;
  border-radius: 4px;
  color: #ffffff !important;
  background: #0070d2 !important;
}

.cancelButton {
  padding: 4px 8px;
  min-width: 100px !important;
  border-radius: 4px;
  color: #50708d !important;
  border: solid 1px #dddbda;
  background-color: #ffffff;
}

.notesText {
  min-height: 130px;
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  border: solid 1px #dddbda;
  background-color: #ffffff;
}

.ungroundNotesText {
  min-height: 130px;
  width: 100%;
  margin-left: 65px !important;
  border-radius: 4px;
  border: solid 1px #dddbda;
  background-color: #ffffff;
}

.ungroundingAlertMessage {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #f8d7da; /* Example background color */
  color: #721c24; /* Example text color */
  padding: 15px;
  text-align: center;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
}

.manualPricing {
  display: block;
  max-width: 60%;
  width: 100%;
}

.manualLabel {
  font-size: 12px;
}

.manualPricingText {
  display: block;
  min-width: 216px;
  width: 100%;
  margin: 0 0 16px 0;
  padding: 5px 12px 5px;
  border-radius: 4px;
  border: solid 1px #dddbda;
  background-color: #ffffff;
}

.notesTextContent {
  font-size: 13px;
}

.adminTextContent {
  font-size: 14px;
  width: 100%;
}

.notesSectionHeader {
  height: 47px;
  padding: 10px 12px;
  box-shadow: 0 1px 0 0 #dddbda;
  background-color: #ffffff;
}

.notesSectionContent {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: #3e3e3c;
  overflow: auto;
}

.custompagination .MuiPagination-ul {
  background-color: white;
}
.custompagination .MuiPaginationItem-root {
  margin: 0px;
  border-radius: 0px;
}
.custompagination .MuiPaginationItem-outlinedPrimary.Mui-selected {
  color: #ffffff !important;
  border: 1px solid #407ed2 !important;
  background-color: #407ed2 !important;
}

.custompagination1 .MuiPagination-ul {
  background-color: #f3f2f2;
}
.custompagination1 .MuiPaginationItem-root {
  margin: 0px;
  margin-top: 50px;
  border-radius: 0px;
}
.custompagination1 .MuiPaginationItem-outlinedPrimary.Mui-selected {
  color: #ffffff !important;
  border: 1px solid #407ed2 !important;
  background-color: #407ed2 !important;
}

.MuiTableCell-head {
  font-weight: 600 !important;
}

.PrivateSwitchBase-root-79 {
  padding: 0px !important;
}

.MuiIconButton-root {
  padding: 0px !important;
}

.MuiTypography-body1 {
  color: #01070c !important;
}

.MuiTab-root {
  text-transform: none !important;
}

.MuiButton-root {
  text-transform: none !important;
}

.MuiTableSortLabel-root {
  display: flex !important;
  justify-content: space-between !important;
}

.tableSortIcon {
  width: 10px;
}

.resultForVin {
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #080707;
}

.topBarAdmin .MuiTabs-indicator {
  height: 3px !important;
  top: 0 !important;
  background-color: #006fd0 !important;
}
.topBarAdmin .Mui-selected {
  background-color: rgba(21, 137, 238, 0.1) !important;
}

.deviderred {
  background-color: #c23934 !important;
}

.reasonUpdate {
  flex-direction: column;
  align-items: flex-start !important;
}

.updateMileageReasonHeading {
  margin-bottom: 8px;
}

.updateMileageReason {
  width: 300px !important;
}

.ungroundReason {
  align-items: center; /* Adjust the margin as needed */
  display: flex;
  gap: 10px;
  margin-left: 15px;
  margin-top: 20px;
}

.ungroundReasonCount {
  align-self: flex-end;
  margin-left: 10px;
}

.selectedReason {
  margin-right: 8px;
}

.unselectedReason {
  margin-right: 34px;
}

.reasonText {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.mileageFomrControl {
  width: 100%;
}

.fullpricinghistorybtn {
  padding: 4px 8px;
  min-width: 70% !important;
  border-radius: 4px;
  color: #50708d !important;
  border: solid 1px #50708d !important;
  background-color: #ffffff;
}

.viewPricinghistoryheader {
  border-bottom: 1px solid lightgray;
}

.vehicalHistoryPricingBtn {
  width: 61px;
  height: 32px !important;
  padding: 1px 13.5px !important;
  border-radius: 4px;
  background-color: #0070d2 !important;
}

.MuiOutlinedInput-inputAdornedStart {
  padding-top: 12px !important;
}

.topDiclaimer {
  padding: 16px 25px 0 25px;
  font-style: italic;
}

.addTile {
  display: flex;
  float: right;
  padding-bottom: 4px;
}

.center-aligin-btn {
  text-align: center;
  margin-top: 15px !important;
  margin-bottom: 15px !important;
}

.model-top {
  margin-top: -58px !important;
}

.conditional-report-body {
  width: calc(100% - 350px);
  padding: 15px;
}

.right-sidebar {
  width: 350px;
  position: fixed;
  top: 52px;
  right: 0px;
}`, "",{"version":3,"sources":["webpack://./src/sass/main.scss","webpack://./src/sass/include/variables.scss","webpack://./src/sass/include/mixins.scss","webpack://./src/sass/include/normalize.scss","webpack://./src/sass/include/forms.scss","webpack://./src/components/Search/Search.scss","webpack://./src/components/Header/Header.scss","webpack://./src/pages/GroundPending/GroundPendng.scss","webpack://./src/components/SearchText/Search.scss","webpack://./src/pages/ConditionReport.scss","webpack://./src/components/AdminStyles.scss","webpack://./src/pages/ConditionReportRequests.scss"],"names":[],"mappings":"AAAC,2DAAA;AC6BD;EACC,cAVa;ADjBd;;AC6BA;EACI,cAfa;ADXjB;;AC4BA;EACI,WAAA;ADzBJ;;AC2BA;EACI,sBAdQ;ADVZ;;AC0BA;EACI,cAfS;ADRb;;ACyBA;EACI,cA3Ba;ADKjB;;ACyBA;EACI,cAnCQ;ADaZ;;ACwBA;EACI,WArCY;ADgBhB;;ACwBA;EACI,cA9BQ;ADSZ;;ACwBA;EACI,cAjCS;ADYb;;ACuBA;EACI,cA1CW;ADsBf;;ACsBA;EACI,cA5Cc;ADyBlB;;ACsBA;EACC,yBAlDa;AD+Bd;;ACqBA;EACI,yBA3DQ;ADyCZ;;ACoBA;EACC,sBA7De;AD4ChB;;AE3DA;;;;;;;EAAA;AAgBA;;;;;;;EAAA;AChBA,2EAAA;AAEA;;;;EAAA;AAMA;EACE,uBAAA,EAAA,MAAA;EACA,0BAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;AH4EF;;AGzEA;;EAAA;AAIA;EACE,SAAA;AH2EF;;AGxEA;+EAAA;AAGA;;;;;EAAA;AAOA;;;;;;;;;;;;;EAaE,cAAA;AHyEF;;AGtEA;;;EAAA;AAKA;;;;EAIE,qBAAA,EAAA,MAAA;EACA,wBAAA,EAAA,MAAA;AHwEF;;AGrEA;;;EAAA;AAKA;EACE,aAAA;EACA,SAAA;AHuEF;;AGpEA;;;EAAA;AAKA;;EAEE,aAAA;AHsEF;;AGnEA;+EAAA;AAGA;;EAAA;AAIA;EACE,6BAAA;AHoEF;;AGjEA;;EAAA;AAIA;;EAEE,UAAA;AHmEF;;AGhEA;+EAAA;AAGA;;EAAA;AAIA;EACE,yBAAA;AHiEF;;AG9DA;;EAAA;AAIA;;EAEE,iBAAA;AHgEF;;AG7DA;;EAAA;AAIA;EACE,kBAAA;AH+DF;;AG5DA;;;EAAA;AAKA;EACE,cAAA;EACA,gBAAA;AH8DF;;AG3DA;;EAAA;AAIA;EACE,gBAAA;EACA,WAAA;AH6DF;;AG1DA;;EAAA;AAIA;EACE,cAAA;AH4DF;;AGzDA;;EAAA;AAIA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AH2DF;;AGxDA;EACE,WAAA;AH2DF;;AGxDA;EACE,eAAA;AH2DF;;AGxDA;+EAAA;AAGA;;EAAA;AAIA;EACE,SAAA;AHyDF;;AGtDA;;EAAA;AAIA;EACE,gBAAA;AHwDF;;AGrDA;+EAAA;AAGA;;EAAA;AAIA;EACE,gBAAA;AHsDF;;AGnDA;;EAAA;AAIA;EAEE,uBAAA;EACA,SAAA;AHqDF;;AGlDA;;EAAA;AAIA;EACE,cAAA;AHoDF;;AGjDA;;EAAA;AAIA;;;;EAIE,iCAAA;EACA,cAAA;AHmDF;;AGhDA;+EAAA;AAGA;;;EAAA;AAKA;;;;;EAAA;AAOA;;;;;EAKE,cAAA,EAAA,MAAA;EACA,aAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;AHgDF;;AG7CA;;EAAA;AAIA;EACE,iBAAA;AH+CF;;AG5CA;;;;;EAAA;AAOA;;EAEE,oBAAA;AH8CF;;AG3CA;;;;;;EAAA;AAQA;;;;EAIE,0BAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;AH6CF;;AG1CA;;EAAA;AAIA;;EAEE,eAAA;AH4CF;;AGzCA;;EAAA;AAIA;;EAEE,SAAA;EACA,UAAA;AH2CF;;AGxCA;;;EAAA;AAKA;EACE,mBAAA;AH0CF;;AGvCA;;;;;;EAAA;AAQA;;EAEE,sBAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;AHyCF;;AGtCA;;;;EAAA;AAMA;;EAEE,YAAA;AHwCF;;AGrCA;;;;EAAA;AAMA;EACE,6BAAA,EAAA,MAAA,EAEA,MAAA;EACA,uBAAA;AHuCF;;AGpCA;;;;EAAA;AAMA;;EAEE,wBAAA;AHsCF;;AGnCA;;EAAA;AAIA;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;AHqCF;;AGlCA;;;EAAA;AAKA;EACE,SAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;AHoCF;;AGjCA;;EAAA;AAIA;EACE,cAAA;AHmCF;;AGhCA;;;EAAA;AAKA;EACE,iBAAA;AHkCF;;AG/BA;+EAAA;AAGA;;EAAA;AAIA;EACE,yBAAA;EACA,iBAAA;AHgCF;;AG7BA;;EAEE,UAAA;AHgCF;;AIzcA;;EAAA;AAOA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,cHEQ;ADscZ;;AIrcA;EACI,iBAAA;EACA,YAAA;AJwcJ;;AIrcA;EACI,WAAA;EACA,YAAA;AJwcJ;;AArdA,eAAA;AACA,yCAAA;AKVA;EACC,aAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;ALmeD;;AKjeA;EACC,UAAA;EACA,WAAA;ALoeD;;AMlfA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,yBAAA;EACA,YAAA;EACA,QAAA;EACA,8BAAA;ANqfF;;AMnfA;EACE,iBAAA;EACA,oBAAA;EACA,0CAAA;EACA,UAAA;ANsfF;;AMpfA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;ANufF;;AMrfA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;ANwfF;;AMtfA;EACE,YAAA;EACA,YAAA;EACA,wBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;ANyfF;;AMvfA;;EAEE,yBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;AN0fF;;AMvfA;EACE,oBAAA;AN0fF;;AMxfA;EACE,oBAAA;AN2fF;;AMxfA;;;EAGE,aAAA;AN2fF;;AMxfA;;;EAGE,mBAAA;AN2fF;;AMxfA;;EAEE,mBAAA;AN2fF;;AOtkBA;EACE,YAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;APykBF;;AOtkBA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;APykBF;;AOtkBA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;APykBF;;AOtkBA;EACE,YAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;APykBF;;AOtkBA;EACE,YAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;APykBF;;AOtkBA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;EACA,yBAAA;APykBF;;AOtkBA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;APykBF;;AOtkBA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;APykBF;;AOtkBA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;APykBF;;AOtkBA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;APykBF;;AOtkBA;EACE,aAAA;EACA,mBAAA;APykBF;;AOtkBA;EACE,aAAA;EACA,mBAAA;APykBF;;AOtkBA;EAGE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;APukBF;;AOnkBA;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;APskBF;;AOnkBA;EACE,YAAA;EACA,cAAA;APskBF;;AOnkBA;EACE,YAAA;EACA,YAAA;EACA,2BAAA;EACA,oCAAA;APskBF;;AOnkBA;EACE,gBAAA;APskBF;;AOnkBA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;APskBF;;AOnkBA;EACE,YAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;APskBF;;AOnkBA;EACE,YAAA;EACA,2BAAA;EACA,oCAAA;APskBF;;AOnkBA;EACE,YAAA;EACA,2BAAA;APskBF;;AOnkBA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;APskBF;;AOnkBA;EACE,YAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;APskBF;;AOnkBA;EACE,2BAAA;APskBF;;AOnkBA;EACE,2BAAA;EACA,6BAAA;EACA,oCAAA;APskBF;;AOnkBA;EACE,YAAA;EACA,YAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;EACA,yBAAA;EACA,oBAAA;APskBF;;AOnkBA;EACE,2BAAA;APskBF;;AOnkBA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;EACA,yBAAA;APskBF;;AOnkBA;EACE,gBAAA;APskBF;;AOnkBA;EACE,yBAAA;APskBF;;AOnkBA;EACE,yBAAA;APskBF;;AOnkBA;EACE,oCAAA;APskBF;;AOpkBA;EAQE,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;APgkBF;;AO9jBA;EAEE,kBAAA;EACA,cAAA;EACA,yBAAA;APgkBF;;AO9jBA;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;APikBF;;AO/jBA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;APkkBF;;AOhkBA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;APmkBF;;AOjkBA;EACE,wBAAA;EACA,8BAAA;EACA,WAAA;APokBF;;AOlkBA;EACE,eAAA;EACA,kBAAA;APqkBF;;AOnkBA;EACE,eAAA;APskBF;;AOnkBA;EACE,eAAA;EAEA,iBAAA;APqkBF;;AOnkBA;EACE,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;APskBF;;AOpkBA;EACE,gBAAA;APukBF;;AOrkBA;EACE,gBAAA;APwkBF;;AOtkBA;EACE,kBAAA;APykBF;;AOvkBA;EACE,gBAAA;AP0kBF;;AOxkBA;EACE,gBAAA;AP2kBF;;AOzkBA;EACE,gBAAA;AP4kBF;;AO1kBA;EACE,6BAAA;AP6kBF;;AO3kBA;EACE,eAAA;EACA,2BAAA;EACA,2BAAA;EACA,cAAA;AP8kBF;;AO5kBA;EACE,eAAA;EACA,4BAAA;EACA,2BAAA;EACA,eAAA;AP+kBF;;AO7kBA;EACE,4BAAA;EACA,2BAAA;APglBF;;AO9kBA;EACE,eAAA;APilBF;;AO/kBA;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,oCAAA;EACA,iCAAA;APklBF;;AOhlBA;EAEE,YAAA;EACA,YAAA;EACA,8BAAA;EACA,2BAAA;EACA,kBAAA;EAIA,oCAAA;EACA,yBAAA;EACA,kCAAA;EACA,8BAAA;AP+kBF;;AO7kBA;EACE,UAAA;EACA,qBAAA;EACA,aAAA;APglBF;;AO9kBA;EAEE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;APglBF;;AO5kBA;EACE,0BAAA;AP+kBF;;AO5kBA;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;AP+kBF;;AO5kBA;EACE,eAAA;AP+kBF;;AO7kBA;EACE,cAAA;APglBF;;AO9kBA;EACE,uBAAA;EACA,cAAA;APilBF;;AO/kBA;EACE,oCAAA;APklBF;;AOhlBA;EACE,oCAAA;APmlBF;;AOjlBA;EAEE,YAAA;EACA,YAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;APmlBF;;AOjlBA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;APolBF;;AOjlBA;EACE,uBAAA;APolBF;;AOjlBA;EACE,yBAAA;APolBF;;AOllBA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;APqlBF;;AOllBA;EACE,YAAA;EACA,aAAA;APqlBF;;AOnlBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;APslBF;;AOnlBA;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;APslBF;;AOplBA;EACE,eAAA;EACA,gBAAA;APulBF;;AOrlBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;APwlBF;;AOtlBA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;APylBF;;AOjlBA;EACE,yBAAA;APolBF;;AOllBA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;APqlBF;;AQhlCA;EACC,aAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;ARmlCD;;AQjlCA;EACC,YAAA;EACA,YAAA;ARolCD;;AQllCA;EACC,UAAA;EACA,WAAA;ARqlCD;;AQnlCA;EACI,YAAA;EACA,YAAA;EACH,gBAAA;EACA,kBAAA;EACG,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;ARslCJ;;ASnnCA;EACE,aAAA;EACA,WAAA;ATsnCF;;ASnnCA;EACI,WAAA;EACA,iBAAA;ATsnCJ;;AS9mCA;EACE,WAAA;ATinCF;;AS9mCA;EAEG,YAAA;EACA,uBAAA;ATgnCH;;ASvmCA;EAEE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;ATymCF;;ASvmCA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AT0mCF;;ASxmCA;EACE,WAAA;EACA,YAAA;EAEA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;AT0mCF;;ASxmCA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;AT2mCF;;ASzmCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;AT4mCF;;AS1mCA;EACE,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,4CAAA;EACA,yBAAA;AT6mCF;;AS1mCA;EAGE,YAAA;EACA,oBAAA;EACA,yBAAA;AT2mCF;;ASvmCA;EACE,gBAAA;EACA,oBAAA;EACA,yBAAA;AT0mCF;;ASxmCA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AT2mCF;;ASzmCA;EAOE,sBAAA;EAEE,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,YAAA;ATqmCJ;;ASnmCA;EAEE,YAAA;EACA,kBAAA;EACA,4CAAA;EACA,yBAAA;ATqmCF;;ASnmCA;EACE,UAAA;EACA,gBAAA;EAEA,kBAAA;EACA,4CAAA;EACA,yBAAA;ATqmCF;;AShmCA;EACE,8BAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;ATmmCF;;ASjmCA;EACE,YAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;ATomCF;;ASlmCA;EACE,qCAAA;ATqmCF;;ASnmCA;EAGE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,yBAAA;ATmmCF;;ASjmCA;EAEE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;ATmmCF;;ASjmCA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;ATomCF;;ASlmCA;EACE,WAAA;EACA,wBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;ATqmCF;;ASnmCA;EACE,WAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;ATsmCF;;ASpmCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;ATumCF;;ASrmCA;EAEE,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;ATumCF;;ASrmCA;EAEE,2BAAA;EACA,2BAAA;EACA,kBAAA;EACA,yBAAA;ATumCF;;ASrmCA;EACE,cAAA;ATwmCF;;AStmCA;EACE,8BAAA;ATymCF;;ASvmCA;EACE,yBAAA;EACA,yBAAA;AT0mCF;;ASxmCA;EACE,0BAAA;EACA,yBAAA;EACA,eAAA;AT2mCF;;AStmCA;EACE,eAAA;ATymCF;;ASvmCA;EACE,2BAAA;EACA,0BAAA;EACA,4BAAA;AT0mCF;;ASxmCA;EACE,2BAAA;AT2mCF;;ASzmCA;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AT4mCF;;AS1mCA;EACE,cAAA;AT6mCF;;AS3mCA;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;AT8mCF;;AS5mCA;EACE,WAAA;EACA,gBAAA;AT+mCF;;AS7mCA;EACE,4BAAA;EACA,6BAAA;ATgnCF;;AS9mCA;EACE,2BAAA;EACA,aAAA;EACA,YAAA;ATinCF;;AS/mCA;EACE,kBAAA;EACA,eAAA;EACA,2BAAA;ATknCF;;AShnCA;EACE,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;ATmnCF;;ASjnCA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;ATonCF;;ASlnCA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;ATqnCF;;ASnnCA;EACE,uBAAA;ATsnCF;;ASpnCA;EAEE,iBAAA;ATsnCF;;ASnnCA;EACE,4BAAA;ATsnCF;;ASnnCA;EAGE,YAAA;EAEA,WAAA;EACA,yBAAA;EACA,kCAAA;ATmnCF;;ASjnCA;EACE,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;ATonCF;;ASlnCA;EACE,eAAA;EACA,YAAA;EACA,YAAA;ATqnCF;;ASnnCA;EACE,gBAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;ATsnCF;;ASpnCA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;ATunCF;;ASrnCA;EACE,oCAAA;ATwnCF;;AStnCA;EACE,oBAAA;ATynCF;;ASvnCA;EACE,aAAA;EACA,sBAAA;AT0nCF;;ASxnCA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;AT2nCF;;ASznCA;EACE,WAAA;AT4nCF;;AS1nCA;EACE,WAAA;EACA,eAAA;EACA,yBAAA;AT6nCF;;AS3nCA;EACE,WAAA;AT8nCF;;AS3nCA;EACE,2BAAA;AT8nCF;;AS5nCA;EACE,qCAAA;AT+nCF;;AS7nCA;EACE,iBAAA;ATgoCF;AS9nCE;EACE,2BAAA;ATgoCJ;AS9nCE;EACE,4BAAA;ATgoCJ;;AS5nCA;EACE,YAAA;AT+nCF;;AS7nCA;EACE,cAAA;ATgoCF;;AS7nCE;EAEE,4BAAA;AT+nCJ;;AS1nCE;EACE,sBAAA;AT6nCJ;;ASvnCA;EACE,2BAAA;AT0nCF;;AStnCA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;ATynCF;;ASvnCA;EACE,UAAA;EAEA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;ATynCF;ASxnCE;EACE,0BAAA;AT0nCJ;;AStnCA;EACE,kBAAA;ATynCF;;ASvnCA;EACE,YAAA;AT0nCF;;ASxnCA;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;AT2nCF;;ASznCA;EACE,WAAA;EAEA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,4CAAA;EACA,iBAAA;AT2nCF;;ASznCA;EACE,oBAAA;AT4nCF;;ASvnCA;EACE,6BAAA;AT0nCF;;ASvnCA;EACE,gBAAA;AT0nCF;;ASvnCA;EACE,yBAAA;AT0nCF;;ASvnCA;EACE,4BAAA;EACA,4BAAA;EACA,6BAAA;AT0nCF;;ASvnCA;EACE,wBAAA;AT0nCF;;ASvnCA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AT0nCF;;ASvnCA;EACE,2BAAA;EACA,8BAAA;AT0nCF;;ASvnCA;EACE,aAAA;EACA,mBAAA;AT0nCF;;ASvnCA;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AT0nCF;;ASvnCA;EACE,kBAAA;EACA,iBAAA;AT0nCF;;ASvnCA;EACE,YAAA;AT0nCF;;ASvnCA;EACE,8BAAA;AT0nCF;;ASvnCA;EACE,aAAA;EACA,8BAAA;AT0nCF;;ASvnCA;EACE,uBAAA;EACA,eAAA;AT0nCF;;ASvnCA;EACE,2BAAA;AT0nCF;;ASvnCA;EACE,kBAAA;AT0nCF;;ASvnCA;EACE,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AT0nCF;;ASvnCA;EACE,mBAAA;EACA,YAAA;AT0nCF;;ASvnCA;EACE,0BAAA;AT0nCF;;AUzuDA;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AV4uDF;;AUzuDA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;AV4uDF;;AUzuDA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,6DAAA;AV4uDF;;AU1uDA;EACE,cAAA;EACA,gBAAA;AV6uDF;;AU3uDA;EACE,YAAA;EACA,WAAA;AV8uDF;;AU3uDA;EACE,YAAA;EACA,oBAAA;EAEA,oCAAA;EACA,yBAAA;EACA,YAAA;AV6uDF;;AU1uDA;EACE,aAAA;EACA,uBAAA;EACA,cAAA;AV6uDF;AU3uDE;EACE,wBAAA;EACA,iBAAA;EACA,WAAA;EACA,oCAAA;AV6uDJ;AU1uDE;EACE,8BAAA;AV4uDJ;;AUvuDE;EACE,uBAAA;AV0uDJ;;AUvuDA;EACE,WAAA;EACA,iBAAA;AV0uDF;;AUxuDA;EACE,YAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,+BAAA;AV2uDF;;AUxuDA;EACE,0BAAA;EAGA,yBAAA;EACA,qBAAA;EAEA,eAAA;EAGA,gBAAA;EACA,4CAAA;EACA,gBAAA;AVsuDF;;AUnuDA;EACE,0BAAA;EAGA,yBAAA;EACA,wBAAA;EAEA,gBAAA;EACA,SAAA;EAGA,4CAAA;EACA,gBAAA;EACA,gBAAA;AViuDF;;AU/tDA;EACE,0BAAA;EAGA,yBAAA;EACA,wBAAA;EAEA,gBAAA;EACA,SAAA;EAGA,4CAAA;EACA,YAAA;EACA,gBAAA;AV6tDF;;AU3tDA;EACE,2BAAA;EACA,SAAA;EACA,OAAA;EACA,iBAAA;EACA,aAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;AV8tDF;;AU3tDA;EAKE,aAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;AV0tDF;;AUvtDA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,2BAAA;AV0tDF;;AUxtDA;EACE,YAAA;EACA,oCAAA;EACA,yBAAA;EACA,oBAAA;AV2tDF;;AUztDA;EACE,YAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8BAAA;EACA,6BAAA;EACA,iCAAA;AV4tDF;;AU1tDA;EACE,YAAA;EACA,YAAA;EACD,oCAAA;EACC,yBAAA;EACA,oBAAA;AV6tDF;;AU1tDA;EACE,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,yBAAA;EACA,8BAAA;AV6tDF;;AU1tDA;EACE,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;AV6tDF;;AU1tDA;EACE,iBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AV6tDF;;AU1tDA;EACI,iBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AV6tDJ;;AU1tDA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,yBAAA,EAAA,6BAAA;EACA,cAAA,EAAA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,yCAAA;AV6tDF;;AU1tDA;EACE,cAAA;EACA,cAAA;EACA,WAAA;AV6tDF;;AU1tDA;EACE,eAAA;AV6tDF;;AU1tDA;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AV6tDF;;AU1tDA;EACE,eAAA;AV6tDF;;AU1tDA;EACE,eAAA;EACA,WAAA;AV6tDF;;AU1tDA;EAEE,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;AV4tDF;;AUztDA;EAEE,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;AV2tDF;;AUvtDE;EACE,uBAAA;AV0tDJ;AUxtDE;EACE,WAAA;EACA,kBAAA;AV0tDJ;AUxtDE;EACE,yBAAA;EACA,oCAAA;EACA,oCAAA;AV0tDJ;;AUttDE;EACE,yBAAA;AVytDJ;AUvtDE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AVytDJ;AUvtDE;EACE,yBAAA;EACA,oCAAA;EACA,oCAAA;AVytDJ;;AUttDA;EACE,2BAAA;AVytDF;;AUttDA;EACE,uBAAA;AVytDF;;AUvtDA;EACE,uBAAA;AV0tDF;;AUxtDA;EACE,yBAAA;AV2tDF;;AUztDA;EACE,+BAAA;AV4tDF;;AUztDA;EACE,+BAAA;AV4tDF;;AUztDA;EACE,wBAAA;EACA,yCAAA;AV4tDF;;AU1tDA;EACE,WAAA;AV6tDF;;AU1tDA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AV6tDF;;AUztDE;EACE,sBAAA;EACA,iBAAA;EACA,oCAAA;AV4tDJ;AU1tDE;EACE,oDAAA;AV4tDJ;;AUxtDA;EACE,oCAAA;AV2tDF;;AUxtDA;EACE,sBAAA;EACA,kCAAA;AV2tDF;;AUztDA;EACE,kBAAA;AV4tDF;;AUztDA;EACE,uBAAA;AV4tDF;;AUztDA;EACE,mBAAA,EAAA,gCAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AV4tDF;;AUztDA;EACE,oBAAA;EACA,iBAAA;AV4tDF;;AUztDA;EACE,iBAAA;AV4tDF;;AUztDA;EACE,kBAAA;AV4tDF;;AUztDA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AV4tDF;;AU1tDA;EACE,WAAA;AV6tDF;;AU3tDA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;EACA,yBAAA;AV8tDF;;AU5tDA;EACE,kCAAA;AV+tDF;;AU7tDA;EACE,WAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,oCAAA;AVguDF;;AU7tDA;EACE,4BAAA;AVguDF;;AU7tDA;EACE,yBAAA;EACA,kBAAA;AVguDF;;AU7tDA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AVguDF;;AWppEA;EACI,kBAAA;EACA,2BAAA;EACA,8BAAA;AXupEJ;;AWrpEA;EACI,4BAAA;AXwpEJ;;AWtpEA;EACI,yBAAA;EACA,aAAA;AXypEJ;;AWvpEA;EACI,YAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;AX0pEJ","sourcesContent":[" /* Make sure this variables file always gets loaded first */\n@import \"include/variables.scss\";\n\n@import \"include/mixins.scss\";\n@import \"include/normalize.scss\";\n@import \"include/paths.scss\";\n@import \"include/forms.scss\";\n\n\n/* Components */\n/* nothing in here should ever conflict */\n\n// global components\n@import \"../components/Search/Search.scss\";\n@import \"../components/Header/Header.scss\";\n@import \"../pages/GroundPending/GroundPendng.scss\";\n@import \"../components/SearchText/Search.scss\";\n@import '../pages/ConditionReport.scss';\n@import '../components/AdminStyles.scss';\n@import '../pages/ConditionReportRequests.scss';","$animSpeed: 0.3s;\n\n$maxMobile: 510px;\n$minTablet: 511px;\n$maxTablet: 768px;\n$minDesktop: 769px;\n$minWidescreen: 1025px;\n\n\n$focusStyleWhite: 2px solid #fff;\n$focusStyleBlack: 2px solid #000;\n$focusStyleRed: 2px solid #cc0000;\n\n\n$colorBody: #6A6A6A;\n$colorBodyDark: #333;\n\n$colorBodyDarker: #666666;\n$colorTargetRed: #cc0000;\n$colorDarkGray: #444444;\n$colorLtGray: #9a9a9a;\n$colorLtGreen: #e9f3e4;\n$colorLtGreenAlt: #39b54a;\n$colorLtBlue: rgb(195,224,231);\n$colorGreen: rgb(3,114,54);\n$colorBlue: rgb(5,70,207);\n$colorTeal: #309ab0;\n$colorGreen: #7fc14a;\n\n.color--light-gray{\n\tcolor: $colorLtGray;\n}\n.color--target-red {\n    color: $colorTargetRed;\n}\n.color--white {\n    color: #fff;\n}\n.color--blue {\n    color: $colorBlue;\n}\n.color--success {\n    color: $colorGreen;\n}\n.color--error {\n    color: $colorTargetRed;\n}\n\n.color--body {\n    color: $colorBody;\n}\n.color--body-dark {\n    color: $colorBodyDark;\n}\n\n.color--teal {\n    color: $colorTeal;\n}\n\n.color--green {\n    color: $colorGreen;\n}\n.color--light-green {\n    color: $colorLtGreen;\n}\n.color--light-green-alt {\n    color: $colorLtGreenAlt;\n}\n\n.bg-color--light-gray{\n\tbackground-color: $colorLtGray;\n}\n.bg-color--body{\n    background-color: $colorBody;\n}\n.bg-color--body-dark{\n\tbackground-color: $colorBodyDark;\n}\n","/**\nCredits: mikewgd - http://snippetrepo.com/snippets/sass-mixin-for-vendor-prefix\n@mixin vendor\nEasily apply styles and adding vendor prefixes will be added with ease.\n@param name - css property\n@param arg - css values\nUsage: @include vendor(border-radius, 4px);\n**/\n@mixin vendor($name, $argument) {\n   -webkit-#{$name}: #{$argument};\n   -ms-#{$name}: #{$argument};\n   -moz-#{$name}: #{$argument};\n   -o-#{$name}: #{$argument};\n    #{$name}: #{$argument};\n}\n\n/**\nCredits: mikewgd - http://snippetrepo.com/snippets/sass-mixin-for-vendor-prefix\n@mixin vendor\nEasily apply styles and adding vendor prefixes will be added with ease.\n@param name - css property\n@param arg - css values\nUsage: @include vendor(border-radius, 4px);\n**/\n@mixin vendor-Filter($name, $argument, $value) {\n   -webkit-#{$name}: #{$argument}unquote(\"(\"#{$value}\")\");\n   -ms-#{$name}: #{$argument}unquote(\"(\"#{$value}\")\");\n   -moz-#{$name}: #{$argument}unquote(\"(\"#{$value}\")\");\n   -o-#{$name}: #{$argument}unquote(\"(\"#{$value}\")\");\n    #{$name}: #{$argument}unquote(\"(\"#{$value}\")\");\n}\n\n\n\n@mixin animation($animate) {\n    -webkit-animation: $animate;\n    -moz-animation: $animate;\n    -o-animation: $animate;\n    animation: $animate;\n}\n\n@mixin keyframes($animationName) {\n    @-webkit-keyframes #{$animationName} {\n        @content;\n    }\n    @-moz-keyframes #{$animationName} {\n        @content;\n    }\n    @-o-keyframes #{$animationName} {\n        @content;\n    }\n    @keyframes #{$animationName} {\n        @content;\n    }\n}\n\n@mixin opacity($value) {\n    $value2: $value * 100;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=$value2)\";\n    filter: alpha(opacity=$value2);\n    -moz-opacity: $value;\n    -khtml-opacity: $value;\n    opacity: $value;\n}\n\n@mixin transition($time) {\n    -webkit-transition: $time;\n    -moz-transition: $time;\n    -o-transition: $time;\n    -ms-transition: $time;\n    transition: $time;\n}\n@mixin for-mobile(){\n  @media screen and (max-width: $maxMobile){ @content; }\n}\n@mixin for-tablet(){\n  @media screen and (min-width: $minTablet) and (max-width: $maxTablet){ @content; }\n}\n@mixin for-desktop(){\n  @media screen and (min-width: $minDesktop){ @content; }\n}\n@mixin for-widescreen(){\n  @media screen and (min-width: $minWidescreen){ @content; }\n}\n\n\n@mixin for-retina(){\n    @media\n    only screen and (-webkit-min-device-pixel-ratio: 2),\n    only screen and (   min--moz-device-pixel-ratio: 2),\n    only screen and (     -o-min-device-pixel-ratio: 2/1),\n    only screen and (        min-device-pixel-ratio: 2),\n    only screen and (                min-resolution: 192dpi),\n    only screen and (                min-resolution: 2dppx) {\n        @content;\n    }\n}\n\n\n// @mixin retinaImageRepeatX($path, $width, $height, $ext) {\n// \tbackground: url($basePath + $path + \"_1x.\" + $ext) repeat-x scroll 0 0 transparent;\n// \t@media only screen and (-webkit-min-device-pixel-ratio: 1.5),\n//     only screen and (-o-min-device-pixel-ratio: 3/2),\n//     only screen and (min--moz-device-pixel-ratio: 1.5),\n//     only screen and (min-device-pixel-ratio: 1.5) {\n//         background: url($basePath + $path + \".\" + $ext) repeat-x scroll 0 0 transparent;\n//         background-size: $width $height;\n// \t}\n// }\n//\n// @mixin retinaImageRepeat($path, $width, $height, $ext) {\n// \tbackground: url($basePath + $path + \"_1x.\" + $ext) repeat scroll 0 0 transparent;\n// \t@media only screen and (-webkit-min-device-pixel-ratio: 1.5),\n//     only screen and (-o-min-device-pixel-ratio: 3/2),\n//     only screen and (min--moz-device-pixel-ratio: 1.5),\n//     only screen and (min-device-pixel-ratio: 1.5) {\n//         background: url($basePath + $path + \".\" + $ext) repeat scroll 0 0 transparent;\n//         background-size: $width $height;\n// \t}\n// }\n//\n// @mixin retinaImage($path, $width, $height, $ext) {\n// \tbackground: url($basePath + $path + \".\" + $ext) 0 0 transparent;\n// \t@media only screen and (-webkit-min-device-pixel-ratio: 1.5),\n//     only screen and (-o-min-device-pixel-ratio: 3/2),\n//     only screen and (min--moz-device-pixel-ratio: 1.5),\n//     only screen and (min-device-pixel-ratio: 1.5) {\n//         background: url($basePath + $path + \".\" + $ext) 0 0 transparent;\n//         background-size: $width $height;\n// \t}\n// }\n//\n\n//\n// @mixin hitbox() {\n//     background-image: url(hack);\n// }\n","/*! normalize.css v3.0.2 | MIT License | github.com/necolas/normalize.css */\n\n/**\n * 1. Set default font family to sans-serif.\n * 2. Prevent iOS text size adjust after orientation change, without disabling\n *    user zoom.\n */\n\nhtml {\n  font-family: sans-serif; /* 1 */\n  -ms-text-size-adjust: 100%; /* 2 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/**\n * Remove default margin.\n */\n\nbody {\n  margin: 0;\n}\n\n/* HTML5 display definitions\n   ========================================================================== */\n\n/**\n * Correct `block` display not defined for any HTML5 element in IE 8/9.\n * Correct `block` display not defined for `details` or `summary` in IE 10/11\n * and Firefox.\n * Correct `block` display not defined for `main` in IE 11.\n */\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\n/**\n * 1. Correct `inline-block` display not defined in IE 8/9.\n * 2. Normalize vertical alignment of `progress` in Chrome, Firefox, and Opera.\n */\n\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block; /* 1 */\n  vertical-align: baseline; /* 2 */\n}\n\n/**\n * Prevent modern browsers from displaying `audio` without controls.\n * Remove excess height in iOS 5 devices.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Address `[hidden]` styling not present in IE 8/9/10.\n * Hide the `template` element in IE 8/9/11, Safari, and Firefox < 22.\n */\n\n[hidden],\ntemplate {\n  display: none;\n}\n\n/* Links\n   ========================================================================== */\n\n/**\n * Remove the gray background color from active links in IE 10.\n */\n\na {\n  background-color: transparent;\n}\n\n/**\n * Improve readability when focused and also mouse hovered in all browsers.\n */\n\na:active,\na:hover {\n  outline: 0;\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * Address styling not present in IE 8/9/10/11, Safari, and Chrome.\n */\n\nabbr[title] {\n  border-bottom: 1px dotted;\n}\n\n/**\n * Address style set to `bolder` in Firefox 4+, Safari, and Chrome.\n */\n\nb,\nstrong {\n  font-weight: bold;\n}\n\n/**\n * Address styling not present in Safari and Chrome.\n */\n\ndfn {\n  font-style: italic;\n}\n\n/**\n * Address variable `h1` font-size and margin within `section` and `article`\n * contexts in Firefox 4+, Safari, and Chrome.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/**\n * Address styling not present in IE 8/9.\n */\n\nmark {\n  background: #ff0;\n  color: #000;\n}\n\n/**\n * Address inconsistent and variable font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` affecting `line-height` in all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsup {\n  top: -0.5em;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Remove border when inside `a` element in IE 8/9/10.\n */\n\nimg {\n  border: 0;\n}\n\n/**\n * Correct overflow not hidden in IE 9/10/11.\n */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * Address margin not present in IE 8/9 and Safari.\n */\n\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * Address differences between Firefox and other browsers.\n */\n\nhr {\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  height: 0;\n}\n\n/**\n * Contain overflow in all browsers.\n */\n\npre {\n  overflow: auto;\n}\n\n/**\n * Address odd `em`-unit font size rendering in all browsers.\n */\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * Known limitation: by default, Chrome and Safari on OS X allow very limited\n * styling of `select`, unless a `border` property is set.\n */\n\n/**\n * 1. Correct color not being inherited.\n *    Known issue: affects color of disabled elements.\n * 2. Correct font properties not being inherited.\n * 3. Address margins set differently in Firefox 4+, Safari, and Chrome.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit; /* 1 */\n  font: inherit; /* 2 */\n  margin: 0; /* 3 */\n}\n\n/**\n * Address `overflow` set to `hidden` in IE 8/9/10/11.\n */\n\nbutton {\n  overflow: visible;\n}\n\n/**\n * Address inconsistent `text-transform` inheritance for `button` and `select`.\n * All other form control elements do not inherit `text-transform` values.\n * Correct `button` style inheritance in Firefox, IE 8/9/10/11, and Opera.\n * Correct `select` style inheritance in Firefox.\n */\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/**\n * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n *    and `video` controls.\n * 2. Correct inability to style clickable `input` types in iOS.\n * 3. Improve usability and consistency of cursor style between image-type\n *    `input` and others.\n */\n\nbutton,\nhtml input[type=\"button\"], /* 1 */\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n  cursor: pointer; /* 3 */\n}\n\n/**\n * Re-set default cursor for disabled elements.\n */\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\n/**\n * Remove inner padding and border in Firefox 4+.\n */\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n/**\n * Address Firefox 4+ setting `line-height` on `input` using `!important` in\n * the UA stylesheet.\n */\n\ninput {\n  line-height: normal;\n}\n\n/**\n * It's recommended that you don't attempt to style these elements.\n * Firefox's implementation doesn't respect box-sizing, padding, or width.\n *\n * 1. Address box sizing set to `content-box` in IE 8/9/10.\n * 2. Remove excess padding in IE 8/9/10.\n */\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Fix the cursor style for Chrome's increment/decrement buttons. For certain\n * `font-size` values of the `input`, it causes the cursor style of the\n * decrement button to change from `default` to `text`.\n */\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Address `appearance` set to `searchfield` in Safari and Chrome.\n * 2. Address `box-sizing` set to `border-box` in Safari and Chrome\n *    (include `-moz` to future-proof).\n */\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box; /* 2 */\n  box-sizing: content-box;\n}\n\n/**\n * Remove inner padding and search cancel button in Safari and Chrome on OS X.\n * Safari (but not Chrome) clips the cancel button when the search input has\n * padding (and `textfield` appearance).\n */\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * Define consistent border, margin, and padding.\n */\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n * 1. Correct `color` not being inherited in IE 8/9/10/11.\n * 2. Remove padding so people aren't caught out if they zero out fieldsets.\n */\n\nlegend {\n  border: 0; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Remove default vertical scrollbar in IE 8/9/10/11.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * Don't inherit the `font-weight` (applied by a rule above).\n * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.\n */\n\noptgroup {\n  font-weight: bold;\n}\n\n/* Tables\n   ========================================================================== */\n\n/**\n * Remove most spacing between table cells.\n */\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ntd,\nth {\n  padding: 0;\n}\n","/**\n* Forms\n**/\n.form {\n\n}\n\n.form-textarea {\n    resize: none;\n    width: 100%;\n    padding: 1em;\n    height: 13em;\n    color: $colorBody;\n}\n\n.form-textarea__count {\n    font-size: .75em;\n    color: white;\n}\n\n.form-input--text {\n    width: 100%;\n    padding: 1em;\n}\n",".sidebarlink {\n\tdisplay: flex;\n\tcolor: #e1e9fc;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tpadding: 20px 40px;\n\tlist-style: none;\n\theight: 60px;\n\ttext-decoration: none;\n\tfont-size: 18px;\n\tcolor: #495057;\n}\n.searchDiv {\n\twidth: 10%;\n\tpadding: 1%;\n}",".container {\n  position: fixed;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 50px;\n  box-shadow: 0 2px 0px 0 rgba(0, 0, 0, 0.2);\n  background-color: #ffffff;\n  z-index: 800;\n  top: 0px;\n  justify-content: space-between;\n}\n.imageHolder {\n  padding: 3px 13px;\n  display: inline-flex;\n  border-right: 1px solid rgb(204, 204, 204);\n  width: 50%;\n}\n.textStyle1 {\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n.textStyleGray {\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  background-color: #d3d3d3;\n}\n.auctionSales {\n  width: 250px;\n  height: 20px;\n  margin: 5px 0 7px 15.5px;\n  font-family: \"ToyotaTypeBook\";\n  font-size: 16px;\n  font-style: normal;\n  line-height: 1.54;\n  letter-spacing: normal;\n  align-self: center;\n}\n.dealerName,\n.userInfo {\n  padding: 0px 0px 0px 10px;\n  font-family: \"ToyotaTypeBook\";\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.54;\n  letter-spacing: normal;\n  color: #080707;\n  display: inline-flex;\n}\n\n#dealer-menu {\n  top: 34px !important;\n}\n#tenant-menu {\n  top: 34px !important;\n}\n\n.brandingWrapper,\n.dealerContianer,\n.rightContainer {\n  display: flex;\n}\n\n.dealerContianer,\n.dealerName,\n.userInfo {\n  align-items: center;\n}\n\n.dealerContianer,\n.userInfo {\n  padding-right: 32px;\n}\n\n",".searchLabel {\n  height: 18px;\n  font-size: 15px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #3e3e3c;\n}\n\n.searchLabelHeader {\n  height: 28px;\n  font-size: 18px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #3e3e3c;\n  margin-bottom: 20px;\n}\n\n.grounding {\n  margin-left: 40%;\n  position: relative;\n  margin-top: 10%;\n}\n\n.noMatchesFrame {\n  width: 425px;\n  height: 76px;\n  padding: 14px 30px 16px 16px;\n  border-radius: 4px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);\n  border: solid 1px #dddbda;\n  background-color: #ffffff;\n  display: block;\n  margin: 1% 0 0 0;\n}\n\n.noMatches {\n  height: 18px;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #3e3e3c;\n}\n\n.carRecordFound {\n  width: 425px;\n  height: 50px;\n  margin-top: 8px;\n  padding: 16px;\n  border-radius: 4px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);\n  border: solid 1px #dddbda;\n  background-color: #ffffff;\n}\n\n.imageFound {\n  width: 162px;\n  height: 130px;\n  margin: 18px 10px 2px 2px;\n  border-radius: 4px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);\n}\n\n.line {\n  width: 340px;\n  height: 1px;\n  margin: 4px 0 8px;\n  border: solid 1px #c23934;\n}\n\n.label {\n  width: 85px;\n  height: 18px;\n  margin: 8px 24px 4px 0;\n  font-family: ToyotaTypeBook;\n  font-size: 12px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #3e3e3c;\n}\n\n.value {\n  width: 85px;\n  height: 18px;\n  margin: 8px 24px 4px 0;\n  font-family: ToyotaTypeBook;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #3e3e3c;\n  font-weight: normal;\n}\n\n.cardSection {\n  display: flex;\n  flex-direction: row;\n}\n\n.cardContent {\n  display: flex;\n  flex-direction: row;\n}\n\n.vehicleMakeModel {\n  // width: 300px;\n  // height: 24px;\n  margin: 0 69px 0 0;\n  font-size: 16px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #080707;\n  // padding-bottom: 20px;\n}\n\n.home {\n  background: #f3f2f2;\n  height: 100vh;\n  overflow: scroll;\n}\n\n.form {\n  height: 70vh;\n  overflow: auto;\n}\n\n.customerReturnDate {\n  width: 425px;\n  height: 32px;\n  margin-top: 10px !important;\n  background-color: #ffffff !important;\n}\n\n.customerReturnStyle {\n  margin-top: 20px;\n}\n\n.groundVehicleMFS {\n  width: 425px;\n  height: 70px;\n  margin-top: 20px;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: solid 1px #dddbda;\n  background-color: #faffbd;\n}\n\n.groundVehicleMFS p {\n  width: 339px;\n  height: 54px;\n  font-family: \"ToyotaTypeBook\";\n  font-size: 13px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #3e3e3c;\n}\n\n.odometer {\n  width: 425px;\n  margin-top: 20px !important;\n  background-color: #ffffff !important;\n}\n\n.odometerBox {\n  width: 450px;\n  margin-top: 20px !important;\n}\n\n.groundVehiclePLV {\n  width: 425px;\n  height: 70px;\n  margin-top: 20px;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: solid 1px #dddbda;\n  background-color: #faffbd;\n}\n\n.groundVehiclePLV p {\n  width: 339px;\n  height: 54px;\n  font-family: \"ToyotaTypeBook\";\n  font-size: 13px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #3e3e3c;\n}\n\n.keysReturnedBox {\n  margin-top: 20px !important;\n}\n\n.keysReturned {\n  margin-top: 20px !important;\n  margin-right: 10px !important;\n  background-color: #ffffff !important;\n}\n\n.Rectangle-3 {\n  width: 174px;\n  height: 52px;\n  margin: 8px 23px 0 0;\n  padding: 16px;\n  border-radius: 4px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);\n  border: solid 1px #dddbda;\n  background-color: #ffffff;\n  display: inline-flex;\n}\n\n.vehicleCondition {\n  margin-top: 20px !important;\n}\n\n.pickUpLocationBox {\n  width: 371px;\n  height: 100px;\n  margin: 8px 0 0;\n  padding: 8px 16px;\n  border-radius: 4px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);\n  border: solid 1px #dddbda;\n  background-color: #ffffff;\n}\n\n.pickUpLocation {\n  margin-top: 20px;\n}\n\n.MuiStepIcon-root.MuiStepIcon-active {\n  color: #0091ff !important;\n}\n\n.MuiStepIcon-root.MuiStepIcon-completed {\n  color: #0091ff !important;\n}\n\n.MuiButton-containedPrimary {\n  background-color: #0070d2 !important;\n}\n.listingPageCard {\n  // width: 80%;\n  // position: relative;\n  // top: 60px;\n  // left: 5%;\n  // background-color: #ffffff;\n  // display: flex;\n  // margin-bottom: 20px;\n  position: relative;\n  top: 60px;\n  background-color: #ffffff;\n  margin: 2% 3%;\n}\n.Year-Make-Model-Col {\n  // width: 90%;\n  border-radius: 4px;\n  margin-top: 5%;\n  background-color: #ffffff;\n}\n.Year-Make-Model-Col-details {\n  border-radius: 4px;\n  margin-top: 3%;\n  background-color: #ffffff;\n}\n.grounding-Vehicle-Price-Option {\n  margin-top: 5%;\n  border-radius: 4px;\n  background-color: #ffffff;\n}\n.Vehicle-Price-Option {\n  margin-top: 5%;\n  border-radius: 4px;\n  background-color: #ffffff;\n  max-width: 250px;\n}\n.priceOptions {\n  display: flex !important;\n  justify-content: space-between;\n  width: 100%;\n}\n.VehicleStepper {\n  margin-top: -2%;\n  border-radius: 4px;\n}\ndiv.vehicleMakeModel {\n  font-size: 13px;\n  // width: 350px;\n}\ndiv.vehicleMakeModel1 {\n  font-size: 16px;\n  // width: 350px;\n  font-weight: bold;\n}\n.textStyle {\n  font-family: ToyotaTypeBook;\n  font-size: 13px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.9;\n  letter-spacing: normal;\n  color: #080707;\n  display: block;\n}\n.margin__space {\n  margin-left: 19%;\n}\n.margin__space1 {\n  margin-left: 55%;\n}\n.margin__space2 {\n  margin-left: 21.5%;\n}\n.margin__space3 {\n  margin-left: 56%;\n}\n.margin__space4 {\n  margin-left: 20%;\n}\n.margin__space5 {\n  margin-left: 16%;\n}\n.margin__space6 {\n  margin-left: 27.5% !important;\n}\n.textStyleTotalFee {\n  font-size: 14px;\n  font-weight: 800 !important;\n  font-family: ToyotaTypeBook;\n  color: #cc0000;\n}\n.totalFeeSum {\n  font-size: 21px;\n  font-weight: 1000 !important;\n  font-family: ToyotaTypeBook;\n  margin-left: 5%;\n}\n.textBold {\n  font-weight: 1000 !important;\n  font-family: ToyotaTypeBook;\n}\n.textSize {\n  font-size: 14px;\n}\n.MuiCheckbox-root {\n  color: #dddbda !important;\n  width: 16px !important;\n  height: 16px !important;\n  margin: 2px 8px 2px 0 !important;\n  padding: 5.2px 3.8px 6.8px 4.2px !important;\n  border-radius: 2px !important;\n  border: solid 1px #dddbda !important;\n  background-color: #fff !important;\n}\n.PassonVehicleStyle {\n  // width: 50%;\n  width: 120px;\n  height: 32px;\n  margin: 2px 9px 0 0 !important;\n  padding: 1px 0px !important;\n  border-radius: 4px;\n  // border: solid 1px #0070d2 !important;\n  // color: #0070d2 !important;\n  // background-color: #ffffff;\n  background-color: #e0e0e0 !important;\n  color: #ffffff !important;\n  text-transform: initial !important;\n  margin-bottom: 10px !important;\n}\n.progressStyle {\n  width: 70%;\n  margin: 10px 0 10px 0;\n  display: flex;\n}\n.img {\n  // height: 120px;\n  display: block;\n  max-width: 400px;\n  overflow: hidden;\n  width: 78%;\n  margin: auto;\n  border: 1px solid lightgray;\n  // height: 400px;\n}\n\n.pendingImgBlock {\n  padding: 4% 10% !important;\n}\n\n.pendingImg {\n  display: block;\n  max-width: 263px;\n  width: 100%;\n  overflow: hidden;\n  border: 1px solid lightgray;\n}\n\n.NavigatorButtons {\n  margin-top: 5px;\n}\n.textStyleWarning {\n  color: #cc0000;\n}\n.MuiLinearProgress-root {\n  height: 10px !important;\n  width: inherit;\n}\n.MuiLinearProgress-barColorSecondary {\n  background-color: #cc0000 !important;\n}\n.MuiLinearProgress-colorSecondary {\n  background-color: #d8d8d8 !important;\n}\n.button {\n  // width: 46%;\n  width: 135px;\n  height: 32px;\n  text-transform: initial !important;\n  margin-bottom: 10px !important;\n  padding: 1px 0px !important;\n}\n.purchasedScreenTotal {\n  width: 250px;\n  height: 2px;\n  margin: 8px 0 5px;\n  background-color: #dddbda;\n}\n\n.paddingCSS {\n  padding: 0px !important;\n}\n\n.MuiCheckbox-colorSecondary.Mui-checked {\n  color: #0070d2 !important;\n}\n.checkedIcon {\n  width: 20px;\n  height: 20px;\n  border: solid 1px #dddbda !important;\n  border-radius: 3px;\n}\n\n.nodataImage {\n  width: 500px;\n  height: 300px;\n}\n.listingPageCardNoData {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: 100vh;\n}\n\n.loadingSpinneradminReportSearch {\n  position: relative;\n  padding-top: 30%;\n  left: 50%;\n}\n.nodataText {\n  font-size: 22px;\n  font-weight: 300;\n}\n.loaderText {\n  font-size: 22px;\n  font-weight: 300;\n  text-align: center;\n}\n.vin {\n  color: #0091ff;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n// .MuiIconButton-root{\n//   background-color: white !important;\n//   color:gray !important;\n// }\n\n.vehicalPriceOptions {\n  padding: 3px 15px 3px 0px;\n}\n.vehiclepriceopt {\n  display: flex;\n  justify-content: space-between;\n  padding: 1px;\n}\n",".sidebarlink {\n\tdisplay: flex;\n\tcolor: #e1e9fc;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tpadding: 20px 40px;\n\tlist-style: none;\n\theight: 60px;\n\ttext-decoration: none;\n\tfont-size: 18px;\n\tcolor: #495057;\n}\n.searchInput {\n\twidth: 425px;\n\tborder: none;\n}\n.searchDiv {\n\twidth: 10%;\n\tpadding: 1%;\n}\n.search {\n    width: 425px;\n    height: 32px;\n\tmargin-top: 10px;\n\tpadding-left: 10px;\n    border-radius: 4px;\n    border: solid 1px #dddbda;\n    background-color: #ffffff;\n    display: flex;\n    flex-direction: row;\n  }",".myContainerLayout {\n  display: flex;\n  width: 100%;\n}\n\n.conditionPageCard {\n    width: 100%;\n    padding-top: 50px;\n    // margin-top: 4%;\n  // border:1px solid red;\n  // margin: 10% 15% 10% 5%;\n  // position: relative;\n  // background: #f3f2f2;\n}\n\n.ungroundConditionPageCard {\n  width: 100%;\n}\n\n.purchasesidebar {\n  // width: 27%;\n   width: 410px;\n   background-color: white;\n  // border:1px solid green;\n}\n//.conditionPageCardReports {\n  // width: 70%;\n  // margin: 5% 0% 0% 20%;\n  // position: absolute;\n  // background: #f3f2f2;\n//}\n.reportTitle {\n  // width: 350px;\n  height: 30px;\n  font-family: ToyotaType;\n  font-size: 17px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #080707;\n}\n.damageTitle {\n  width: 100%;\n  height: 30px;\n  font-family: ToyotaType;\n  font-size: 14px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #080707;\n  text-align: center;\n  display: block;\n}\n.pendingReport {\n  width: 100%;\n  height: 30px;\n  // font-family: ToyotaType;\n  font-size: 13px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: rgba(0, 0, 0, 0.25);\n  text-align: center;\n  display: block;\n}\n.Pending-Inspection-R {\n  width: 165px;\n  height: 20px;\n  margin-left: 31%;\n  font-family: ToyotaType;\n  font-size: 13px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.54;\n  letter-spacing: normal;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ConditionReportSection {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 20px 0px !important;\n  width: 100%;\n}\n.ConditionCardBody {\n  margin: 8px 0px 15px;\n  padding: 16px;\n  border-radius: 4px;\n  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);\n  background-color: #ffffff;\n}\n\n.ConditionReportInspection {\n  // width: 140px;\n  // height: 33px;\n  padding: 8px;\n  border-radius: 100px;\n  background-color: #04844b;\n  // margin-left: 245px;\n  // float: right;\n}\n.ConditionReportInspectionPending{\n  padding: 4px 8px;\n  border-radius: 100px;\n  background-color: #c23934;\n}\n.BadgeValue {\n  width: 122px;\n  height: 15px;\n  font-size: 12px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #ffffff;\n}\n.inspectionStatusWarning {\n  // width: 138px;\n  // width: 238px;\n  //   height: 33px;\n  //   padding: 4px 18px;\n  //   border-radius: 100px;\n  //   //margin-left: 10px;\n  background-color: #c00;\n  // // margin-left: 1rem;\n    height: 33px;\n    padding: 4px 8px;\n    border-radius: 100px;\n    margin-left: auto;\n    width: 140px;\n}\n.ConditionCard {\n  // width: 123%;\n  height: 70px;\n  border-radius: 4px;\n  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);\n  background-color: #ffffff;\n}\n.ConditionCardDamage {\n  width: 90%;\n  margin-top: 12px;\n  // height: 70px;\n  border-radius: 4px;\n  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);\n  background-color: #ffffff;\n}\n//.ConditionCardMargin {\n  // margin-right: 25px !important;\n//}\n.detailedReport {\n  font-size: 0.685rem !important;\n  font-weight: bold !important;\n  border-radius: 4px;\n  text-align: center;\n  border: solid 1px #0070d2;\n  background-color: #ffffff;\n}\n.disclaimer {\n  height: 50px;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.6;\n  letter-spacing: normal;\n  text-align: left;\n}\n.closeButton {\n  text-transform: capitalize !important;\n}\n.smallCardTitle {\n  // height: 14px;\n  // margin: 0 0 10px;\n  font-size: 12px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  // line-height: 1.17;\n  letter-spacing: normal;\n  text-align: center;\n  color: #3e3e3c !important;\n}\n.smallCardTitle1 {\n  // height: 14px;\n  margin: 0 0 10px;\n  font-size: 11.6px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.17;\n  letter-spacing: normal;\n  text-align: center;\n  color: #3e3e3c;\n}\n.smallCardBody {\n  height: 24px;\n  font-size: 14px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: center;\n  color: #080707;\n}\n.inputFieldTextArea {\n  width: 100%;\n  height: 180px !important;\n  margin: 2px 0 0;\n  padding: 8px 4px 4px 12px;\n  border-radius: 4px;\n  border: solid 1px #dddbda;\n  background-color: #ffffff;\n  resize: none;\n}\n.inputFieldTextAreaDamage {\n  width: 100%;\n  height: 80px !important;\n  margin: 2px 0 0;\n  padding: 8px 4px 4px 12px;\n  border-radius: 4px;\n  border: solid 1px #dddbda;\n  background-color: #ffffff;\n  resize: none;\n}\n.LabelTextTextArea {\n  width: 94px;\n  height: 18px;\n  margin: 0 6px 0 0;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #3e3e3c;\n}\n.LabelTextTextAreaDamage {\n  // height: 18px;\n  margin: 5px 6px 0 0;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #3e3e3c;\n}\n.vehicleSectionCR {\n  // width: 83%;\n  margin: 16px 10px 40px 10px;\n  padding: 16px 9px 32px 24px;\n  border-radius: 4px;\n  background-color: #ffffff;\n}\n.table {\n  min-width: 250;\n}\n.MuiTableCell-root {\n  border-bottom: none !important;\n}\n.MuiTableHead-root {\n  background-color: #fafaf9;\n  color: #514f4d !important;\n}\n.MuiTableCell-sizeSmall {\n  padding: 6px 24px 6px 16px;\n  color: #514f4d !important;\n  font-size: 13px;\n}\n//.MuiTableCell-alignRight {\n  // font-weight: 900 !important;\n//}\n.MuiButton-label{\n  cursor: pointer;\n}\n.align_right {\n  font-weight: 900 !important;\n  font-size: 13px !important;\n  line-height: 20px !important;\n}\n.MuiTableContainer-root {\n  box-shadow: none !important;\n}\n.disclaimerVRS {\n  margin: 7.5px 0 0;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.6;\n  letter-spacing: normal;\n  text-align: left;\n  color: #e02020;\n}\n.warningColor {\n  color: #0070d2;\n}\n.warningColorTable {\n  color: #0070d2 !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n}\n.viewReportBody {\n  width: 100%;\n  margin-left: 20%;\n}\n.vehicleDetailsMargin {\n  margin-left: 10px !important;\n  margin-right: 10px !important;\n}\n.viewReportCards {\n  box-shadow: none !important;\n  padding: 10px;\n  width: 150px;\n}\n.viewReportHeader {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 900 !important;\n}\n.techIssuesHeader {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 900 !important;\n  background-color: #c23934;\n}\n.techIssueCenter{\n  font-size: 20px;\n  margin: 0px 30px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  background-color:white;\n}\n.viewReportCenter {\n  font-size: 20px;\n  margin: 0px 30px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #080707;\n}\n.image-gallery-svg {\n  height: 50px !important;\n}\n.ConditionCardReportSpace {\n  // margin-top: 4% !important ;\n  padding-top: 15px;\n}\n\n.ungroundConditionCardReportSpace {\n  padding-top: 10px !important ;\n}\n\n.conditionTopBar {\n  // width: 64%;\n  // position: fixed;\n  height: 40px;\n  // top: 51px;\n  z-index: 10;\n  background-color: #ffffff;\n  border-bottom: 1px solid lightgray;\n}\n.conditionTopBarStyles {\n  width: 109px;\n  height: 20px;\n  margin: 3px 0 3px 8px;\n  font-size: 13px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.54;\n  letter-spacing: normal;\n  color: #006dcc;\n  position: relative;\n}\n.conditionTopBarLayout {\n  margin-left: 4%;\n  float: right;\n  padding: 8px;\n}\n.reportFooter {\n  margin: 32px 0 0;\n  padding: 12px 16px 12px 804px;\n  box-shadow: 0 -2px 0 0 #dddbda;\n  background-color: #f3f2f2;\n}\n.closeButton {\n  width: 61px;\n  height: 32px;\n  padding: 1px 13.5px;\n  border-radius: 4px;\n  color: #ffffff !important;\n}\n.saveBtnEnable {\n  background-color: #3f51b5 !important;\n}\n.notesCharCount {\n  align-self: flex-end;;\n}\n.noteSubSection {\n  display: flex;\n  flex-direction: column;\n}\n.closePassBtn {\n  width: 80px;\n  height: 32px;\n  padding: 1px 13.5px;\n  border-radius: 4px;\n  color: #ffffff !important;\n  background-color: #0070d2 !important;\n}\n.galleryView {\n  float: left;\n}\n.hrLine {\n  height: 1px;\n  margin: 8px 0px;\n  background-color: #dddbda;\n}\n.alignleft {\n  float: left;\n}\n\n.paddingTop {\n  margin-top: 20px !important;\n}\n.accessoriestextStyle {\n  text-transform: capitalize !important;\n}\n.experiorSpacing {\n  padding: 0px 30px;\n\n  .MuiList-padding{\n    padding-top: 0px !important;\n  }\n  .MuiListItem-gutters{\n    padding-left: 0px !important;\n  }\n\n}\n.textStyle1 {\n  color: white;\n}\n.errorColor {\n  color: #c23934;\n}\n.galleryView {\n  .image-gallery-image {\n    // max-height: 440px !important;\n    max-height: 465px !important;\n  }\n}\n.codereportimggallery {\n  // width: 26vw !important;\n  .image-gallery-thumbnails-wrapper {\n    width: 35vw !important;\n  }\n  // .image-gallery-image {\n  //   max-height: 370px !important;\n  // }\n}\n.image-gallery-thumbnail-image {\n  max-height: 70px !important;\n}\n\n\n.accessoriestextStyle {\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  justify-content: left;\n  padding: 5px;\n}\n.accessoriestinlineextStyle {\n  width: 33%;\n  // height: 50px;\n  font-size: 13px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  p{\n    font-size: 14px !important; \n  }\n}\n\n.image-gallery-content {\n  overflow-x: hidden;\n}\n.textWidth {\n  width: 140px;\n}\n.detailedReportRates {\n  font-size: 13px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.6;\n  letter-spacing: normal;\n  text-align: right;\n  padding: 10px;\n}\n.imageReportSection {\n  width: 100%;\n  // height: 180px;\n  margin: 24px 1px 16px;\n  border-radius: 4px;\n  background-color: #fff;\n  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);\n  padding-top: 40px;\n} \n.icontooltip{\n  display: inline-flex;\n}\n// .MuiIconButton-root{\n//   color: #005fb2 !important;\n// }\n.align_right11{\n  font-weight: 900px !important;\n\n}\n.icontooltip{\n  margin-top: -8px;\n}\n\n.MuiRadio-colorSecondary.Mui-checked{\n  color: #0070d2 !important\n}\n\n.updateMileagePrice {\n  padding-top: 16px !important;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n\n.arbitrationReviewRightPanel {\n  width: calc(100% + 24px);\n}\n\n.locationData {\n  display: flex;\n  flex-direction: column;\n  text-align: end;\n}\n\n.paddingCSS-arbitrationReview {\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n\n.inspectionData {\n  display: flex;\n  flex-direction: row;\n}\n\n.inputFieldTextAreaArbitrationReview {\n  width: 100%;\n  margin: 2px 0 0;\n  padding: 8px 4px 4px 12px;\n  border-radius: 4px;\n  border: solid 1px #dddbda;\n  background-color: #ffffff;\n  resize: none;\n}\n\n.arbitrationSubmit {\n  text-align: center;\n  padding-top: 1rem;\n}\n\n.formControl {\n  width: 125px;\n}\n\n.adminNoteHeading {\n  vertical-align: top !important;\n}\n\n.dealerNoteStyle {\n  display: flex;\n  justify-content: space-between;\n}\n\n.reviewWidth {\n  width: 400px !important;\n  text-align: end;\n}\n\n.reportSubTitle {\n  font-weight: 500 !important;\n}\n\n.rightPanelDataRight {\n  align-self: center;\n}\n\n.dealerNotesData {\n  padding: 0.5px 8px;\n  border: 1px solid rgba(224, 224, 224, 1);\n  border-radius: 4px;\n  max-width: 200px;\n}\n\n.reportVhcleTitle {\n  display: table-cell;\n  width: 240px;\n}\n\n.addressData {\n  text-transform: capitalize;\n}",".adminSearchCard {\n  width: 700px;\n  position: relative;\n  top: 101px;\n  left: 20%;\n  height: 275px;\n}\n\n.adminSearchCardBody {\n  display: flex;\n  padding-right: 5px;\n  margin: 25px;\n}\n\n.adminSearcheader {\n  text-align: center;\n  display: flex;\n  background-color: #000;\n  background-image: linear-gradient(258deg, #000, var(--black));\n}\n.adminSearcheaderColor {\n  color: #ffffff;\n  margin-top: 20px;\n}\n.cover {\n  width: 200px;\n  padding: 2%;\n}\n\n.topBarAdmin {\n  height: 48px;\n  top: 50px !important;\n  // padding: 7px;\n  background-color: #ffffff !important;\n  color: #080707 !important;\n  margin: auto;\n}\n\n.tabset {\n  display: flex;\n  justify-content: center;\n  margin: 0 auto;\n\n  .MuiTabs-indicator {\n    bottom: unset !important;\n    top: 0 !important;\n    height: 3px;\n    background-color: #407ed2 !important;\n  }\n\n  .Mui-selected {\n    background: #e7f3fd !important;\n  }\n}\n\n.tablepagination {\n  .MuiTablePagination-select {\n    background-color: white;\n  }\n}\n.adminTabsSection {\n  width: 100%;\n  padding-top: 90px;\n}\n.notesSection {\n  width: 280px;\n  height: calc(100vh - 50px);\n  background-color: #ffffff;\n  z-index: 1110 !important;\n  position: sticky;\n  top: 50px;\n  overflow-y: auto;\n  box-shadow: 1px 2px 4px #969696;\n}\n\n.manualPricingSidebar {\n  height: calc(100vh - 53px);\n  // min-height: 500px;\n  // height: 100vh;\n  background-color: #ffffff;\n  z-index: 3 !important;\n  // margin-left: ; // 80%\n  position: fixed;\n  // top: 40px;\n  // right: 3%;\n  margin-top: 52px;\n  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);\n  overflow-y: auto;\n  // min-width: 350px;\n}\n.updatePricingSidebar {\n  height: calc(100vh - 53px);\n  // min-height: 500px;\n  // height: 100vh;\n  background-color: #ffffff;\n  z-index: 1110 !important;\n  // margin-left: ; // 80%\n  position: sticky;\n  top: 50px;\n  // right: 3%;\n  // margin-top: 52px;\n  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);\n  min-width: 350px;\n  overflow-y: auto;\n}\n.updateUngroundingSidebar {\n  height: calc(100vh - 53px);\n  // min-height: 500px;\n  // height: 100vh;\n  background-color: #ffffff;\n  z-index: 1110 !important;\n  // margin-left: ; // 80%\n  position: sticky;\n  top: 50px;\n  // right: 3%;\n  // margin-top: 52px;\n  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.25);\n  width: 450px;\n  overflow-y: auto;\n}\n.swipeFilterBtn {\n  position: sticky !important;\n  bottom: 0;\n  left: 0;\n  padding: 8px 16px;\n  display: flex;\n  justify-content: space-evenly;\n  width: 100%;\n  background: #fff;\n}\n\n.purchasePassBtn {\n  // position: absolute !important;\n  // bottom: 65px;\n  // left: 10px;\n  // padding: 20px 16px;\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  background: #fff;\n}\n\n.passButton {\n  width: 140px;\n  height: 32px;\n  margin: 0 8px 0 0;\n  padding: 1px 6px 1px 7px;\n  border-radius: 4px;\n  border: solid 1px #0070d2 !important;\n  font-size: 0.65rem !important;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5 !important;\n}\n.passButtonDisabled {\n  width: 130px;\n  background-color: #e0e0e0 !important;\n  color: #ffffff !important;\n  border: 0 !important;\n}\n.purchaseButton {\n  width: 140px;\n  height: 30px;\n  font-size: 0.65rem !important;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5 !important;\n  letter-spacing: normal;\n  text-align: center;\n  color: #fff !important;\n  background: #0070d2 !important;\n  border-radius: 4px !important;\n  border: solid 1px grey !important;\n}\n.purchaseButtonDisabled {\n  width: 130px;\n  height: 32px;\n background-color: #e0e0e0 !important;\n  color: #ffffff !important;\n  border: 0 !important;\n}\n\n.updateButton {\n  padding: 4px 8px;\n  min-width: 100px !important;\n  border-radius: 4px;\n  color: #ffffff !important;\n  background: #0070d2 !important;\n}\n\n.cancelButton {\n  padding: 4px 8px;\n  min-width: 100px !important;\n  border-radius: 4px;\n  color: #50708d !important;\n  border: solid 1px #dddbda;\n  background-color: #ffffff;\n}\n\n.notesText {\n  min-height: 130px;\n  width: 100%;\n  padding: 10px;\n  border-radius: 4px;\n  border: solid 1px #dddbda;\n  background-color: #ffffff;\n}\n\n.ungroundNotesText {\n    min-height: 130px;\n    width: 100%;\n    margin-left: 65px !important;\n    border-radius: 4px;\n    border: solid 1px #dddbda;\n    background-color: #ffffff;\n}\n\n.ungroundingAlertMessage{\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #f8d7da; /* Example background color */\n  color: #721c24; /* Example text color */\n  padding: 15px;\n  text-align: center;\n  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.manualPricing {\n  display: block;\n  max-width: 60%;\n  width: 100%;\n}\n\n.manualLabel {\n  font-size: 12px;\n}\n\n.manualPricingText {\n  display: block;\n  min-width: 216px;\n  width: 100%;\n  margin: 0 0 16px 0;\n  padding: 5px 12px 5px;\n  border-radius: 4px;\n  border: solid 1px #dddbda;\n  background-color: #ffffff;\n}\n\n.notesTextContent {\n  font-size: 13px;\n}\n\n.adminTextContent {\n  font-size: 14px;\n  width: 100%;\n}\n\n.notesSectionHeader {\n  // width: 264px;\n  height: 47px;\n  padding: 10px 12px;\n  box-shadow: 0 1px 0 0 #dddbda;\n  background-color: #ffffff;\n}\n\n.notesSectionContent {\n  // width: 217px;\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.54;\n  letter-spacing: normal;\n  color: #3e3e3c;\n  overflow: auto;\n}\n\n.custompagination {\n  .MuiPagination-ul {\n    background-color: white;\n  }\n  .MuiPaginationItem-root {\n    margin: 0px;\n    border-radius: 0px;\n  }\n  .MuiPaginationItem-outlinedPrimary.Mui-selected {\n    color: #ffffff !important;\n    border: 1px solid #407ed2 !important;\n    background-color: #407ed2 !important;\n  }\n}\n.custompagination1 {\n  .MuiPagination-ul {\n    background-color: #f3f2f2;\n  }\n  .MuiPaginationItem-root {\n    margin: 0px;\n    margin-top: 50px;\n    border-radius: 0px;\n  }\n  .MuiPaginationItem-outlinedPrimary.Mui-selected {\n    color: #ffffff !important;\n    border: 1px solid #407ed2 !important;\n    background-color: #407ed2 !important;\n  }\n}\n.MuiTableCell-head {\n  font-weight: 600 !important;\n}\n\n.PrivateSwitchBase-root-79 {\n  padding: 0px !important;\n}\n.MuiIconButton-root {\n  padding: 0px !important;\n}\n.MuiTypography-body1 {\n  color: #01070c !important;\n}\n.MuiTab-root {\n  text-transform: none !important;\n}\n\n.MuiButton-root {\n  text-transform: none !important;\n}\n\n.MuiTableSortLabel-root {\n  display: flex !important;\n  justify-content: space-between !important;\n}\n.tableSortIcon {\n  width: 10px;\n}\n\n.resultForVin {\n  font-size: 15px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #080707;\n}\n\n.topBarAdmin {\n  .MuiTabs-indicator {\n    height: 3px !important;\n    top: 0 !important;\n    background-color: #006fd0 !important;\n  }\n  .Mui-selected {\n    background-color: rgba(21, 137, 238, 0.1) !important;\n  }\n}\n\n.deviderred {\n  background-color: #c23934 !important;\n}\n\n.reasonUpdate {\n  flex-direction: column;\n  align-items: flex-start !important;\n}\n.updateMileageReasonHeading {\n  margin-bottom: 8px;\n}\n\n.updateMileageReason {\n  width: 300px !important;\n\n}\n.ungroundReason {\n  align-items: center;/* Adjust the margin as needed */\n  display: flex;\n  gap: 10px;\n  margin-left: 15px;\n  margin-top: 20px;\n}\n\n.ungroundReasonCount{\n  align-self: flex-end;\n  margin-left: 10px;\n}\n\n.selectedReason {\n  margin-right: 8px;\n}\n\n.unselectedReason {\n  margin-right: 34px;\n}\n\n.reasonText {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.mileageFomrControl{\n  width: 100%;\n}\n.fullpricinghistorybtn{\n  padding: 4px 8px;\n  min-width: 70% !important;\n  border-radius: 4px;\n  color: #50708d !important;\n  border: solid 1px #50708d !important;\n  background-color: #ffffff;\n}\n.viewPricinghistoryheader{\n  border-bottom: 1px solid lightgray;\n}\n.vehicalHistoryPricingBtn{\n  width: 61px;\n  height: 32px !important;\n  padding: 1px 13.5px !important;\n  border-radius: 4px;\n  background-color: #0070d2 !important;\n}\n\n.MuiOutlinedInput-inputAdornedStart {\n  padding-top: 12px !important;\n}\n\n.topDiclaimer {\n  padding: 16px 25px 0 25px;\n  font-style: italic;\n}\n\n.addTile {\n  display: flex;\n  float: right;\n  padding-bottom: 4px;\n}",".center-aligin-btn {\n    text-align: center;\n    margin-top: 15px !important;\n    margin-bottom: 15px !important;\n}\n.model-top {\n    margin-top: -58px !important;\n}\n.conditional-report-body{\n    width: calc( 100% - 350px);\n    padding: 15px;\n}\n.right-sidebar{\n    width: 350px;\n    position: fixed;\n    top:52px;\n    right:0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
